import React from 'react'

import CustomNotification from 'controls/customNotification';import {DatasourcePropertiesPanelManager} from 'areas/dashboards/graph-editor-extensions/datasourcePropertiesPanelManager';
import BaseFormatPanel from './baseFormatPanel';
import ElementPropertiesPanel from 'areas/services/designer/graph-editor-extensions/elementPropertiesPanel';
import ImageUploader from 'controls/imageUploader';
import Menus from './menus'
import {translator} from 'core/localization/localization';
import {isOneOf} from "tools/utils";
import {DesignerEvents} from "controls/designer/shared";
import {isCellGenerated} from "controls/designer/utils";
import {AntInput} from "controls/react/ant/antInput";
import {Section} from "controls/react/layout/section";
import {FormEntry} from "controls/react/form/formEntry";
import {AntCheckbox} from "controls/react/ant/antCheckbox";
import {IconButton} from "controls/react";
import {createRoot} from "react-dom/client";
import {createContainer} from "controls/react/ant/antModal";
import {DataSourceEditor} from "controls/designer/dataSourcesManager/dataSourceEditor";
import {Observer} from "mobx-react";


const i18n = translator({
  "Preserve Layout": {
    "no": "Behold oppsett",
    "en": "Preserve layout"
  },
  "Show labels in view mode": {
    "no": "Vis tekstobjekter i visningsmodus"
  },
  "Layout": {
    "no": "Oppsett"
  },
  "Set Image": {
    "no": "Last opp",
    "en": "Set image"
  },
  "This cell is generated and no properties for it will be saved": {
    "no": "Denne cellen er generert og ingen instillinger for den blir lagret"
  },
  "Show Maximize/Minimize icon": {
    "no": "Vis maksimer/minimer ikon",
    "en": "Show maximize/minimize Icon"
  },
  "Preview Padding": {
    "no": "Visning polstring",
    "en": "Preview padding"
  },
  "Container background": {
    "no": "Beholder bakgrunn",
    "en": "Container background"
  },
  "Container background opacity": {
    "no": "Beholder gjennomsiktighet",
    "en": "Container background opacity"
  },
  "Layout Grid": {
    "no": "Oppsettsguide",
    "en": "Layout grid"
  },
  "Layout grid tooltip": {
    "en": "This grid can be used when designing dashboards for lower resolutions.",
    "no": "Denne oppsetsguiden brukes når du designer dashboard for mindre oppløsninger."
  },
  "Design": {
    "no": "Design"
  },
  "Snap to grid": {
    "no": "Fest til grid",
    "en": "Snap to grid"
  },
  "Ordering": {
    "no": "Rekkefølge"
  },
  "Ordering-tooltip": {
    "en": "Set a number to determine the order widgets will be when they do not fit available resolution. Lowest number comes first.",
    "no": "Sett et tall for å bestemme rekkefølgen widgetene blir vist når de ikke passer tilgjengelig oppløsning. Laveste tall kommer først."
  },
  "Don't display on lower resolutions": {
    "no": "Ikke vis på lavere oppløsning"
  },
  "Dont-display-tooltip": {
    "en": " If checked the widget/shape will not be displayed on lower resolutions.",
    "no": "Hvis valgt vil ikke widget/formen vises på lavere oppløsning."
  },
	'Anchor left border': {},
	'Anchor right border': {}
});

function allowDataSourceTab(editorUi) {
	return isOneOf(editorUi.config.mode, ['presentation', 'application']);
}

/**
 * Copyright (c) 2006-2012, JGraph Ltd
 */
window.Format = function (editorUi, container) {
	this.editorUi = editorUi;
	this.container = container;
	this.rendering = false;

	if (allowDataSourceTab(editorUi)) {
		const r = createContainer()
		this.datasourcePropertiesPanelContainer = r[2]
		this.datasourcePropertiesPanelRoot = r[0]
		this.datasourcePropertiesPanelRoot.render(<DataSourceEditor store={this.editorUi.designer.store}/>)
	}
};

/**
 * Returns information about the current selection.
 */
Format.prototype.labelIndex = 0;

/**
 * Returns information about the current selection.
 */
Format.prototype.currentIndex = 0;

/**
 * Adds the label menu items to the given menu and parent.
 */
Format.prototype.init = function () {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;

	this.update = mxUtils.bind(this, function (sender, evt) {
		this.clearSelectionState();
		this.refresh();
	});

	graph.getSelectionModel().addListener(mxEvent.CHANGE, this.update);
	graph.addListener(mxEvent.EDITING_STARTED, this.update);
	graph.addListener(mxEvent.EDITING_STOPPED, this.update);
	graph.getModel().addListener(mxEvent.CHANGE, this.update);
	graph.addListener(mxEvent.ROOT, mxUtils.bind(this, function () {
		this.refresh();
	}));

	this.refresh();
};

/**
 * Returns information about the current selection.
 */
Format.prototype.clearSelectionState = function () {
	this.selectionState = null;
};

/**
 * Returns information about the current selection.
 */
Format.prototype.getSelectionState = function () {
	if (this.selectionState == null) {
		this.selectionState = this.createSelectionState();
	}

	return this.selectionState;
};

/**
 * Returns information about the current selection.
 */
Format.prototype.createSelectionState = function () {
	var cells = this.editorUi.editor.graph.getSelectionCells();
	var result = this.initSelectionState();

	for (var i = 0; i < cells.length; i++) {
		this.updateSelectionStateForCell(result, cells[i], cells);
	}

	return result;
};

/**
 * Returns information about the current selection.
 */
Format.prototype.initSelectionState = function () {
	return {
		vertices: [], edges: [], x: null, y: null, width: null, height: null, style: {},
		containsImage: false, containsLabel: false, fill: true, glass: true, rounded: true,
		comic: true, autoSize: false, image: true, shadow: true
	};
};

/**
 * Returns information about the current selection.
 */
Format.prototype.updateSelectionStateForCell = function (result, cell, cells) {
	var graph = this.editorUi.editor.graph;

	if (graph.getModel().isVertex(cell)) {
		result.vertices.push(cell);
		var geo = graph.getCellGeometry(cell);

		if (geo != null) {
			if (geo.width > 0) {
				if (result.width == null) {
					result.width = geo.width;
				}
				else if (result.width != geo.width) {
					result.width = '';
				}
			}
			else {
				result.containsLabel = true;
			}

			if (geo.height > 0) {
				if (result.height == null) {
					result.height = geo.height;
				}
				else if (result.height != geo.height) {
					result.height = '';
				}
			}
			else {
				result.containsLabel = true;
			}

			if (!geo.relative || geo.offset != null) {
				var x = (geo.relative) ? geo.offset.x : geo.x;
				var y = (geo.relative) ? geo.offset.y : geo.y;

				if (result.x == null) {
					result.x = x;
				}
				else if (result.x != x) {
					result.x = '';
				}

				if (result.y == null) {
					result.y = y;
				}
				else if (result.y != y) {
					result.y = '';
				}
			}
		}
	}
	else if (graph.getModel().isEdge(cell)) {
		result.edges.push(cell);
	}

	var state = graph.view.getState(cell);

	if (state != null) {
		result.autoSize = result.autoSize || this.isAutoSizeState(state);
		result.glass = result.glass && this.isGlassState(state);
		result.rounded = result.rounded && this.isRoundedState(state);
		result.comic = result.comic && this.isComicState(state);
		result.image = result.image && this.isImageState(state);
		result.shadow = result.shadow && this.isShadowState(state);
		result.fill = result.fill && this.isFillState(state);

		var shape = mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null);
		result.containsImage = result.containsImage || shape == 'image';

		for (var key in state.style) {
			var value = state.style[key];

			if (value != null) {
				if (result.style[key] == null) {
					result.style[key] = value;
				}
				else if (result.style[key] != value) {
					result.style[key] = '';
				}
			}
		}
	}
};

/**
 * Returns information about the current selection.
 */
Format.prototype.isFillState = function (state) {
	return state.view.graph.model.isVertex(state.cell) ||
		mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null) == 'arrow' ||
		mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null) == 'flexArrow';
};

/**
 * Returns information about the current selection.
 */
Format.prototype.isGlassState = function (state) {
	var shape = mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null);

	return (shape == 'label' || shape == 'rectangle' || shape == 'internalStorage' ||
		shape == 'ext' || shape == 'umlLifeline' || shape == 'swimlane' ||
		shape == 'process');
};

/**
 * Returns information about the current selection.
 */
Format.prototype.isRoundedState = function (state) {
	var shape = mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null);

	return (shape == 'label' || shape == 'rectangle' || shape == 'internalStorage' || shape == 'corner' ||
		shape == 'parallelogram' || shape == 'swimlane' || shape == 'triangle' || shape == 'trapezoid' ||
		shape == 'ext' || shape == 'step' || shape == 'tee' || shape == 'process' || shape == 'link' ||
		shape == 'rhombus' || shape == 'offPageConnector' || shape == 'loopLimit' || shape == 'hexagon' ||
		shape == 'manualInput' || shape == 'curlyBracket' || shape == 'singleArrow' ||
		shape == 'doubleArrow' || shape == 'flexArrow' || shape == 'card' || shape == 'umlLifeline'
		|| shape == 'image');
};

/**
 * Returns information about the current selection.
 */
Format.prototype.isComicState = function (state) {
	var shape = mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null);

	return mxUtils.indexOf(['label', 'rectangle', 'internalStorage', 'corner', 'parallelogram', 'note', 'collate',
		'swimlane', 'triangle', 'trapezoid', 'ext', 'step', 'tee', 'process', 'link', 'rhombus',
		'offPageConnector', 'loopLimit', 'hexagon', 'manualInput', 'singleArrow', 'doubleArrow',
		'flexArrow', 'card', 'umlLifeline', 'connector', 'folder', 'component', 'sortShape',
		'cross', 'umlFrame', 'cube', 'isoCube', 'isoRectangle', 'partialRectangle'], shape) >= 0;
};

/**
 * Returns information about the current selection.
 */
Format.prototype.isAutoSizeState = function (state) {
	return mxUtils.getValue(state.style, mxConstants.STYLE_AUTOSIZE, null) == '1';
};

/**
 * Returns information about the current selection.
 */
Format.prototype.isImageState = function (state) {
	var shape = mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null);

	return (shape == 'label' || shape == 'image');
};

/**
 * Returns information about the current selection.
 */
Format.prototype.isShadowState = function (state) {
	var shape = mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE, null);

	return (shape != 'image');
};

/**
 * Adds the label menu items to the given menu and parent.
 */
Format.prototype.clear = function () {
	this.container.innerHTML = '';

	// Destroy existing panels
	if (this.panels != null) {
		for (var i = 0; i < this.panels.length; i++) {
			this.panels[i].destroy && this.panels[i].destroy();
		}
	}

	this.panels = [];
};

Format.prototype.destroy = function(){
	this.datasourcePropertiesPanelRoot?.unmount()
	this.datasourcePropertiesPanelContainer?.remove()
}

/**
 * Adds the label menu items to the given menu and parent.
 */
Format.prototype.refresh = async function () {

	// Performance tweak: No refresh needed if not visible
	if (this.container.style.width == '0px') {
		return;
	}

	var ui = this.editorUi;
	var graph = ui.editor.graph;
	let designer = graph.designer

	const cells = graph.getSelectionCells();

	const aGeneratedCell = cells.find(cell =>{
		return isCellGenerated(cell) || isCellGenerated(cell.parent);
	});

	if(aGeneratedCell) {
		this.container.innerHTML = "<div style='padding: 30px 10px'>" + i18n('This cell is generated and no properties for it will be saved') + "</div>";
		return;
	}

	if(this.rendering)
		return;

	this.rendering = true;

	this.clear();


	var div = document.createElement('div');
	div.style.whiteSpace = 'nowrap';
	div.style.color = 'rgb(112, 112, 112)';
	div.style.textAlign = 'left';
	div.style.cursor = 'default';

	var label = document.createElement('div');
	label.style.border = '1px solid #c0c0c0';
	label.style.borderWidth = '0px 0px 1px 0px';
	label.style.textAlign = 'center';
	label.style.fontWeight = 'bold';
	label.style.overflow = 'hidden';
	label.style.display = (mxClient.IS_QUIRKS) ? 'inline' : 'inline-block';
	label.style.paddingTop = '8px';
	label.style.height = (mxClient.IS_QUIRKS) ? '34px' : '25px';
	label.style.width = '100%';
	this.container.appendChild(div);

	if (graph.isSelectionEmpty()) {
		mxUtils.write(label, mxResources.get('diagram'));
		div.appendChild(label);
		this.panels.push(new DiagramFormatPanel(this, ui, div));
	}
	else if (graph.isEditing()) {
		mxUtils.write(label, mxResources.get('text'));
		div.appendChild(label);
		this.panels.push(new TextFormatPanel(this, ui, div));
	}
	else {
		var containsLabel = this.getSelectionState().containsLabel;
		var currentLabel = null;
		var currentPanel = null;

		var addClickHandler = mxUtils.bind(this, function (elt, panel, index) {
			var clickHandler = mxUtils.bind(this, function (evt) {
				if (currentLabel != elt) {
					if (containsLabel) {
						this.labelIndex = index;
					}
					else {
						this.currentIndex = index;
					}

					if (currentLabel != null) {
						currentLabel.style.backgroundColor = '#d7d7d7';
						currentLabel.style.borderBottomWidth = '1px';
					}

					currentLabel = elt;
					currentLabel.style.backgroundColor = '';
					currentLabel.style.borderBottomWidth = '0px';

					if (currentPanel != panel) {
						if (currentPanel != null) {
							currentPanel.style.display = 'none';
						}

						currentPanel = panel;
						currentPanel.style.display = '';
					}
				}
			});

			mxEvent.addListener(elt, 'click', clickHandler);

			if (index == ((containsLabel) ? this.labelIndex : this.currentIndex)) {
				// Invokes handler directly as a workaround for no click on DIV in KHTML.
				clickHandler();
			}

			return clickHandler
		});

		var idx = 0;

		var panelsCount = 3;
		var canSetDatasource = false;
		var canSetProperties = false;

		if (cells.length == 1) {
			const userData =  ui.getCellValueAsXml(graph.getSelectionCell());
			const cellStyle = graph.getCellStyle(graph.getSelectionCell());

			if (userData.getAttribute("disableDataSourceSettings") != "true"
				&& this.editorUi.designer.store.widgetsManager.get(cells[0]) == null
				&& userData.getAttribute('trigger') == null
				&& allowDataSourceTab(this.editorUi)
				&& (cellStyle.shape != 'label' || cellStyle.strokeColor != 'none')) {
				canSetDatasource = true;
				panelsCount++;
			}
			if (this.editorUi.config.mode == 'service' && cells[0].isVertex() && cells[0].customData) {
				canSetProperties = true;
				panelsCount++;
			}
		}

		var width = {
			4: [20, 20, 23, 35],
			3: [33, 33, 33]
		};

		label.style.backgroundColor = '#d7d7d7';
		label.style.borderLeftWidth = '1px';

		label.style.width = width[panelsCount][0] + '%';

		var label2 = label.cloneNode(false);
		label2.style.width = width[panelsCount][1] + '%';

		var label3 = label.cloneNode(false);
		label3.style.width = width[panelsCount][2] + '%';

		var label4 = label.cloneNode(false);
		label4.style.width = width[panelsCount][3] + '%';

		// Workaround for ignored background in IE
		label2.style.backgroundColor = '#d7d7d7';
		label3.style.backgroundColor = '#d7d7d7';
		label3.style.backgroundColor = '#d7d7d7';
		label4.style.backgroundColor = '#d7d7d7';

		let anyHtmlContainerCells = false;

		for (let cell of cells) {
			const widgetConfig = designer.store.widgetsManager.get(cell)
			if(widgetConfig && widgetConfig.type != 'report'){
				anyHtmlContainerCells = true;
				break;
			}
		}


		if (canSetProperties) {
			mxUtils.write(label4, i18n('Properties'));
			div.appendChild(label4);

			var propertiesPanel = div.cloneNode(false);
			propertiesPanel.style.display = 'none';
			this.panels.push(new ElementPropertiesPanel(this, ui, propertiesPanel));
			this.container.appendChild(propertiesPanel);
			addClickHandler(label4, propertiesPanel, idx++);
		}

		// Style
		if (containsLabel) {
			label2.style.borderLeftWidth = '0px';
		}
		else {
			label.style.borderLeftWidth = '0px';
			mxUtils.write(label, mxResources.get('style'));
			div.appendChild(label);

			var stylePanel = div.cloneNode(false);
			stylePanel.style.display = 'none';
			let panelInstance = new StyleFormatPanel(this, ui, stylePanel, anyHtmlContainerCells)
			this.panels.push(panelInstance);
			this.container.appendChild(stylePanel);

			addClickHandler(label, stylePanel, idx++);
		}

		if(!anyHtmlContainerCells) {
			// Text
			mxUtils.write(label2, mxResources.get('text'));
			div.appendChild(label2);

			var textPanel = div.cloneNode(false);
			textPanel.style.display = 'none';
			this.panels.push(new TextFormatPanel(this, ui, textPanel));
			this.container.appendChild(textPanel);
			addClickHandler(label2, textPanel, idx++);
		}
		// Arrange
		mxUtils.write(label3, mxResources.get('arrange'));
		div.appendChild(label3);

		var arrangePanel = div.cloneNode(false);
		arrangePanel.style.display = 'none';
		this.panels.push(new ArrangePanel(this, ui, arrangePanel));
		this.container.appendChild(arrangePanel);
		addClickHandler(label3, arrangePanel, idx++);


		if (canSetDatasource) {
			mxUtils.write(label4, i18n('Datasource'));
			div.appendChild(label4);

			var datasourcePanel = div.cloneNode(false);
			datasourcePanel.style.display = 'none';

			const editor = ui.editor;
			const graph = editor.graph;

			datasourcePanel.appendChild(this.datasourcePropertiesPanelContainer)
			//this.panels.push(datasourcePropertiesPanelManager.getPanel(this, ui, datasourcePanel));

			this.container.appendChild(datasourcePanel);
			this.showDataSourcePanel = addClickHandler(label4, datasourcePanel, idx++);
		}
	}

	this.rendering = false;
};


/**
 * Adds the label menu items to the given menu and parent.
 */
window.ArrangePanel = function (format, editorUi, container) {
	BaseFormatPanel.call(this, format, editorUi, container);
	this.init();
};

mxUtils.extend(ArrangePanel, BaseFormatPanel);

/**
 * Adds the label menu items to the given menu and parent.
 */
ArrangePanel.prototype.init = function () {
	if(!this.editorUi.editor)
		return;

	var graph = this.editorUi.editor.graph;
	var ss = this.format.getSelectionState();

	this.container.appendChild(this.addLayerOps(this.createPanel()));
	// Special case that adds two panels
	this.addGeometry(this.container);
	this.addEdgeGeometry(this.container);

	if (!ss.containsLabel || ss.edges.length == 0) {
		this.container.appendChild(this.addAngle(this.createPanel()));
	}

	if (!ss.containsLabel && ss.edges.length == 0) {
		this.container.appendChild(this.addFlip(this.createPanel()));
	}

	if (ss.vertices.length > 1) {
		this.container.appendChild(this.addAlign(this.createPanel()));
		this.container.appendChild(this.addDistribute(this.createPanel()));

	}

	this.container.appendChild(this.addGroupOps(this.createPanel()));

	this.addSortingIndex()
}

ArrangePanel.prototype.addSortingIndex = function(){
	let store = this.editorUi.designer.store;
	if(store.config.features.adaptiveLayout !== true)
		return

	let div = document.createElement('div')

	let ui = this.editorUi;
	let graph = ui.editor.graph;
	let cell = graph.getSelectionCell();

	let anchoring = store.viewManager.getAnchoringData(cell)


	const reactRoot = createRoot(div)

	reactRoot.render(<Observer>
		{() =>
			<Section childrenPadding={true}>
				<FormEntry label={i18n('Ordering')}>
					<IconButton iconName={"question-sign"}
					            title={i18n('Ordering-tooltip')}
					            embedded/>
					<AntInput defaultValue={cell.getLayoutIndex()} onChange={value => cell.setLayoutIndex(value)}/>
				</FormEntry>
				<FormEntry>
					<AntCheckbox defaultChecked={cell.getHideOnLowerResolution()}
					             onChange={show => cell.setHideOnLowerResolution(show)}>
						{i18n('Don\'t display on lower resolutions')}
						<IconButton iconName={"question-sign"}
						            title={i18n('Dont-display-tooltip')}
						            embedded/>
					</AntCheckbox>
				</FormEntry>
				<FormEntry model={anchoring} modelField={"left"}>
					<AntCheckbox>
						{i18n('Anchor left border')}
						{/*<IconButton iconName={"question-sign"}*/}
						{/*            title={i18n('Dont-display-tooltip')}*/}
						{/*            embedded/>*/}
					</AntCheckbox>
				</FormEntry>
				<FormEntry model={anchoring} modelField={"right"}>
					<AntCheckbox>
						{i18n('Anchor right border')}
						{/*<IconButton iconName={"question-sign"}*/}
						{/*            title={i18n('Dont-display-tooltip')}*/}
						{/*            embedded/>*/}
					</AntCheckbox>
				</FormEntry>
			</Section>}
	</Observer>)

	this.container.appendChild(div)

	this.listeners.push({
		destroy: function () {
			reactRoot.unmount()
		}
	});
}

ArrangePanel.prototype.addLayerOps = function (div) {
	var ui = this.editorUi;

	var btn = mxUtils.button(mxResources.get('toFront'), function (evt) {
		ui.actions.get('toFront').funct();
	})

	btn.setAttribute('title', mxResources.get('toFront') + ' (' + this.editorUi.actions.get('toFront').shortcut + ')');
	btn.style.width = '100px';
	btn.style.marginRight = '2px';
	btn.setAttribute('class', 'k-button k-primary');

	div.appendChild(btn);

	var btn = mxUtils.button(mxResources.get('toBack'), function (evt) {
		ui.actions.get('toBack').funct();
	})

	btn.setAttribute('title', mxResources.get('toBack') + ' (' + this.editorUi.actions.get('toBack').shortcut + ')');
	btn.style.width = '100px';
	btn.setAttribute('class', 'k-button k-primary');

	div.appendChild(btn);

	return div;
};

/**
 *
 */
ArrangePanel.prototype.addGroupOps = function (div) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;
	var cell = graph.getSelectionCell();
	var ss = this.format.getSelectionState();
	var count = 0;
	var btn;

	div.style.paddingTop = '8px';
	div.style.paddingBottom = '6px';

	if (graph.getSelectionCount() > 1) {
		btn = mxUtils.button(mxResources.get('group'), function (evt) {
			ui.actions.get('group').funct();
		})

		btn.setAttribute('title', mxResources.get('group') + ' (' + this.editorUi.actions.get('group').shortcut + ')');
		btn.style.width = '202px';
		btn.style.marginBottom = '2px';
		btn.setAttribute('class', 'k-button k-primary');
		div.appendChild(btn);
		count++;
	}
	else if (graph.getSelectionCount() == 1 && !graph.getModel().isEdge(cell) && !graph.isSwimlane(cell) &&
		graph.getModel().getChildCount(cell) > 0) {
		btn = mxUtils.button(mxResources.get('ungroup'), function (evt) {
			ui.actions.get('ungroup').funct();
		})

		btn.setAttribute('title', mxResources.get('ungroup') + ' (' + this.editorUi.actions.get('ungroup').shortcut + ')');
		btn.style.width = '202px';
		btn.style.marginBottom = '2px';
		btn.setAttribute('class', 'k-button k-primary');
		div.appendChild(btn);

		count++;
	}

	if (graph.getSelectionCount() == 1 && graph.getModel().isVertex(cell) &&
		graph.getModel().isVertex(graph.getModel().getParent(cell))) {
		if (count > 0) {
			mxUtils.br(div);
		}

		btn = mxUtils.button(mxResources.get('removeFromGroup'), function (evt) {
			ui.actions.get('removeFromGroup').funct();
		})

		btn.setAttribute('title', mxResources.get('removeFromGroup'));
		btn.style.width = '202px';
		btn.style.marginBottom = '2px';
		btn.setAttribute('class', 'k-button k-primary');
		div.appendChild(btn);
		count++;
	}

	if (count == 0) {
		div.style.display = 'none';
	}

	return div;
};

/**
 *
 */
ArrangePanel.prototype.addAlign = function (div) {
	var graph = this.editorUi.editor.graph;
	div.style.paddingTop = '6px';
	div.style.paddingBottom = '12px';
	div.appendChild(this.createTitle(mxResources.get('align')));

	var stylePanel = document.createElement('div');
	stylePanel.style.position = 'relative';
	stylePanel.style.paddingLeft = '0px';
	stylePanel.style.borderWidth = '0px';
	stylePanel.className = 'geToolbarContainer';

	if (mxClient.IS_QUIRKS) {
		div.style.height = '60px';
	}

	var left = this.addButton('geSprite-alignleft', mxResources.get('left'),
		function () {
			graph.alignCells(mxConstants.ALIGN_LEFT);
		}, stylePanel);
	var center = this.addButton('geSprite-aligncenter', mxResources.get('center'),
		function () {
			graph.alignCells(mxConstants.ALIGN_CENTER);
		}, stylePanel);
	var right = this.addButton('geSprite-alignright', mxResources.get('right'),
		function () {
			graph.alignCells(mxConstants.ALIGN_RIGHT);
		}, stylePanel);

	var top = this.addButton('geSprite-aligntop', mxResources.get('top'),
		function () {
			graph.alignCells(mxConstants.ALIGN_TOP);
		}, stylePanel);
	var middle = this.addButton('geSprite-alignmiddle', mxResources.get('middle'),
		function () {
			graph.alignCells(mxConstants.ALIGN_MIDDLE);
		}, stylePanel);
	var bottom = this.addButton('geSprite-alignbottom', mxResources.get('bottom'),
		function () {
			graph.alignCells(mxConstants.ALIGN_BOTTOM);
		}, stylePanel);

	this.styleButtons([left, center, right, top, middle, bottom]);
	right.style.marginRight = '6px';
	div.appendChild(stylePanel);

	return div;
};

/**
 *
 */
ArrangePanel.prototype.addFlip = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;
	div.style.paddingTop = '6px';
	div.style.paddingBottom = '10px';

	var span = document.createElement('div');
	span.style.marginTop = '2px';
	span.style.marginBottom = '8px';
	span.style.fontWeight = 'bold';
	mxUtils.write(span, mxResources.get('flip'));
	div.appendChild(span);

	this.createButton2(div, 'horizontal', '48%',function (evt) {
		graph.toggleCellStyles(mxConstants.STYLE_FLIPH, false);
	});

	this.createButton2(div, 'vertical', '48%',function (evt) {
		graph.toggleCellStyles(mxConstants.STYLE_FLIPV, false);
	});

	return div;
}

/**
 *
 */
ArrangePanel.prototype.addDistribute = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;
	div.style.paddingTop = '6px';
	div.style.paddingBottom = '12px';

	div.appendChild(this.createTitle(mxResources.get('distribute')));

	this.createButton2(div, 'horizontal', '48%',function (evt) {
		graph.distributeCells(true);
	});

	this.createButton2(div, 'vertical', '48%',function (evt) {
		graph.distributeCells(false);
	});

	return div;
};


/**
 *
 */
ArrangePanel.prototype.addAngle = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;
	var ss = this.format.getSelectionState();

	div.style.paddingBottom = '8px';

	var span = document.createElement('div');
	span.style.position = 'absolute';
	span.style.width = '70px';
	span.style.marginTop = '0px';
	span.style.fontWeight = 'bold';

	var input = null;
	var update = null;
	var btn = null;

	if (ss.edges.length == 0) {
		mxUtils.write(span, mxResources.get('angle'));
		div.appendChild(span);

		input = this.addUnitInput(div, '°', 20, 44, function () {
			update.apply(this, arguments);
		});

		mxUtils.br(div);
		div.style.paddingTop = '10px';
	}
	else {
		div.style.paddingTop = '8px';
	}

	if (!ss.containsLabel) {
		var label = mxResources.get('reverse');

		if (ss.vertices.length > 0 && ss.edges.length > 0) {
			label = mxResources.get('turn') + ' / ' + label;
		}
		else if (ss.vertices.length > 0) {
			label = mxResources.get('turn');
		}

		btn = mxUtils.button(label, function (evt) {
			ui.actions.get('turn').funct();
		})
		btn.setAttribute('class', 'k-button k-primary');
		btn.setAttribute('title', label + ' (' + this.editorUi.actions.get('turn').shortcut + ')');
		btn.style.width = '202px';
		div.appendChild(btn);

		if (input != null) {
			btn.style.marginTop = '8px';
		}
	}

	if (input != null) {
		var listener = mxUtils.bind(this, function (sender, evt, force) {
			if (force || document.activeElement != input) {
				ss = this.format.getSelectionState();
				var tmp = parseFloat(mxUtils.getValue(ss.style, mxConstants.STYLE_ROTATION, 0));
				input.value = (isNaN(tmp)) ? '' : tmp + '°';
			}
		});

		update = this.installInputHandler(input, mxConstants.STYLE_ROTATION, 0, 0, 360, '°', null, true);
		this.addKeyHandler(input, listener);

		graph.getModel().addListener(mxEvent.CHANGE, listener);
		this.listeners.push({
			destroy: function () {
				graph.getModel().removeListener(listener);
			}
		});
		listener();
	}

	return div;
};

/**
 *
 */
ArrangePanel.prototype.addGeometry = function (container) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;
	var rect = this.format.getSelectionState();

	var div = this.createPanel();
	div.style.paddingBottom = '8px';

	var span = document.createElement('div');
	span.style.position = 'absolute';
	span.style.width = '50px';
	span.style.marginTop = '0px';
	span.style.fontWeight = 'bold';
	mxUtils.write(span, mxResources.get('size'));
	div.appendChild(span);

	var widthUpdate, heightUpdate, leftUpdate, topUpdate;
	var width = this.addUnitInput(div, 'pt', 84, 44, function () {
		widthUpdate.apply(this, arguments);
	});
	var height = this.addUnitInput(div, 'pt', 20, 44, function () {
		heightUpdate.apply(this, arguments);
	});

	var autosizeBtn = document.createElement('div');
	autosizeBtn.className = 'geSprite geSprite-fit';
	autosizeBtn.setAttribute('title', mxResources.get('autosize') + ' (' + this.editorUi.actions.get('autosize').shortcut + ')');
	autosizeBtn.style.position = 'relative';
	autosizeBtn.style.cursor = 'pointer';
	autosizeBtn.style.marginTop = '-3px';
	autosizeBtn.style.border = '0px';
	autosizeBtn.style.left = '52px';
	mxUtils.setOpacity(autosizeBtn, 50);

	mxEvent.addListener(autosizeBtn, 'mouseenter', function () {
		mxUtils.setOpacity(autosizeBtn, 100);
	});

	mxEvent.addListener(autosizeBtn, 'mouseleave', function () {
		mxUtils.setOpacity(autosizeBtn, 50);
	});

	mxEvent.addListener(autosizeBtn, 'click', function () {
		ui.actions.get('autosize').funct();
	});

	div.appendChild(autosizeBtn);
	this.addLabel(div, mxResources.get('width'), 84);
	this.addLabel(div, mxResources.get('height'), 20);
	mxUtils.br(div);

	var wrapper = document.createElement('div');
	wrapper.style.paddingTop = '8px';
	wrapper.style.paddingRight = '20px';
	wrapper.style.whiteSpace = 'nowrap';
	wrapper.style.textAlign = 'right';
	var opt = this.createCellOption(mxResources.get('constrainProportions'),
		mxConstants.STYLE_ASPECT, null, 'fixed', 'null');
	opt.style.width = '100%';
	wrapper.appendChild(opt);
	div.appendChild(wrapper);

	this.addKeyHandler(width, listener);
	this.addKeyHandler(height, listener);

	widthUpdate = this.addGeometryHandler(width, function (geo, value) {
		if (geo.width > 0) {
			geo.width = Math.max(1, value);
		}
	});
	heightUpdate = this.addGeometryHandler(height, function (geo, value) {
		if (geo.height > 0) {
			geo.height = Math.max(1, value);
		}
	});

	container.appendChild(div);

	var div2 = this.createPanel();
	div2.style.paddingBottom = '30px';

	var span = document.createElement('div');
	span.style.position = 'absolute';
	span.style.width = '70px';
	span.style.marginTop = '0px';
	span.style.fontWeight = 'bold';
	mxUtils.write(span, mxResources.get('position'));
	div2.appendChild(span);

	var left = this.addUnitInput(div2, 'pt', 84, 44, function () {
		leftUpdate.apply(this, arguments);
	});
	var top = this.addUnitInput(div2, 'pt', 20, 44, function () {
		topUpdate.apply(this, arguments);
	});

	mxUtils.br(div2);
	this.addLabel(div2, mxResources.get('left'), 84);
	this.addLabel(div2, mxResources.get('top'), 20);

	var listener = mxUtils.bind(this, function (sender, evt, force) {
		rect = this.format.getSelectionState();

		if (!rect.containsLabel && rect.vertices.length == graph.getSelectionCount() &&
			rect.width != null && rect.height != null) {
			div.style.display = '';

			if (force || document.activeElement != width) {
				width.value = rect.width + ((rect.width == '') ? '' : ' pt');
			}

			if (force || document.activeElement != height) {
				height.value = rect.height + ((rect.height == '') ? '' : ' pt');
			}
		}
		else {
			div.style.display = 'none';
		}

		if (rect.vertices.length == graph.getSelectionCount() &&
			rect.x != null && rect.y != null) {
			div2.style.display = '';

			if (force || document.activeElement != left) {
				left.value = rect.x + ((rect.x == '') ? '' : ' pt');
			}

			if (force || document.activeElement != top) {
				top.value = rect.y + ((rect.y == '') ? '' : ' pt');
			}
		}
		else {
			div2.style.display = 'none';
		}
	});

	this.addKeyHandler(left, listener);
	this.addKeyHandler(top, listener);

	graph.getModel().addListener(mxEvent.CHANGE, listener);
	this.listeners.push({
		destroy: function () {
			graph.getModel().removeListener(listener);
		}
	});
	listener();

	leftUpdate = this.addGeometryHandler(left, function (geo, value) {
		value = value < 0 ? 0 : value;
		if (geo.relative) {
			geo.offset.x = value;
		}
		else {
			geo.x = value;
		}
	});
	topUpdate = this.addGeometryHandler(top, function (geo, value) {
		value = value < 0 ? 0 : value;
		if (geo.relative) {
			geo.offset.y = value;
		}
		else {
			geo.y = value;
		}
	});

	container.appendChild(div2);
};

/**
 *
 */
ArrangePanel.prototype.addGeometryHandler = function (input, fn) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;
	var initialValue = null;

	function update(evt) {
		if (input.value != '') {
			var value = parseFloat(input.value);

			if (value != initialValue) {
				graph.getModel().beginUpdate();
				try {
					var cells = graph.getSelectionCells();

					for (var i = 0; i < cells.length; i++) {
						if (graph.getModel().isVertex(cells[i])) {
							var geo = graph.getCellGeometry(cells[i]);

							if (geo != null) {
								geo = geo.clone();
								fn(geo, value);

								graph.getModel().setGeometry(cells[i], geo);
							}
						}
					}
				}
				finally {
					graph.getModel().endUpdate();
				}

				initialValue = value;
				input.value = value + ' pt';
			}
			else if (isNaN(value)) {
				input.value = initialValue + ' pt';
			}
		}

		mxEvent.consume(evt);
	};

	mxEvent.addListener(input, 'blur', update);
	mxEvent.addListener(input, 'change', update);
	mxEvent.addListener(input, 'focus', function () {
		initialValue = input.value;
	});

	return update;
};

/**
 *
 */
ArrangePanel.prototype.addEdgeGeometry = function (container) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;
	var rect = this.format.getSelectionState();

	var div = this.createPanel();

	var span = document.createElement('div');
	span.style.position = 'absolute';
	span.style.width = '70px';
	span.style.marginTop = '0px';
	span.style.fontWeight = 'bold';
	mxUtils.write(span, mxResources.get('width'));
	div.appendChild(span);

	var widthUpdate, leftUpdate, topUpdate;
	var width = this.addUnitInput(div, 'pt', 20, 44, function () {
		widthUpdate.apply(this, arguments);
	});

	mxUtils.br(div);
	this.addKeyHandler(width, listener);

	function widthUpdate(evt) {
		// Maximum stroke width is 999
		var value = parseInt(width.value);
		value = Math.min(999, Math.max(1, (isNaN(value)) ? 1 : value));

		if (value != mxUtils.getValue(rect.style, 'width', mxCellRenderer.defaultShapes['flexArrow'].prototype.defaultWidth)) {
			graph.setCellStyles('width', value, graph.getSelectionCells());
			ui.fireEvent(new mxEventObject('styleChanged', 'keys', ['width'],
				'values', [value], 'cells', graph.getSelectionCells()));
		}

		width.value = value + ' pt';
		mxEvent.consume(evt);
	};

	mxEvent.addListener(width, 'blur', widthUpdate);
	mxEvent.addListener(width, 'change', widthUpdate);

	container.appendChild(div);

	var listener = mxUtils.bind(this, function (sender, evt, force) {
		rect = this.format.getSelectionState();

		if (rect.style.shape == 'link' || rect.style.shape == 'flexArrow') {
			div.style.display = '';

			if (force || document.activeElement != width) {
				var value = mxUtils.getValue(rect.style, 'width',
					mxCellRenderer.defaultShapes['flexArrow'].prototype.defaultWidth);
				width.value = value + ' pt';
			}
		}
		else {
			div.style.display = 'none';
		}
	});

	graph.getModel().addListener(mxEvent.CHANGE, listener);
	this.listeners.push({
		destroy: function () {
			graph.getModel().removeListener(listener);
		}
	});
	listener();
};

/**
 * Adds the label menu items to the given menu and parent.
 */
window.TextFormatPanel = function (format, editorUi, container) {
	BaseFormatPanel.call(this, format, editorUi, container);
	this.init();
};

mxUtils.extend(TextFormatPanel, BaseFormatPanel);

/**
 * Adds the label menu items to the given menu and parent.
 */
TextFormatPanel.prototype.init = function () {
	this.container.style.borderBottom = 'none';
	this.addFont(this.container);
};

/**
 * Adds the label menu items to the given menu and parent.
 */
TextFormatPanel.prototype.addFont = function (container) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;
	var ss = this.format.getSelectionState();

	var title = this.createTitle(mxResources.get('font'));
	title.style.paddingLeft = '18px';
	title.style.paddingTop = '10px';
	title.style.paddingBottom = '6px';
	container.appendChild(title);

	var stylePanel = this.createPanel();
	stylePanel.style.paddingTop = '2px';
	stylePanel.style.paddingBottom = '2px';
	stylePanel.style.position = 'relative';
	stylePanel.style.marginLeft = '-2px';
	stylePanel.style.borderWidth = '0px';
	stylePanel.className = 'geToolbarContainer';

	if (mxClient.IS_QUIRKS) {
		stylePanel.style.display = 'block';
	}

	if (graph.cellEditor.isContentEditing()) {
		var cssPanel = stylePanel.cloneNode();

		var cssMenu = this.addMenu(mxResources.get('style'),
			mxResources.get('style'), true, 'formatBlock', cssPanel);
		cssMenu.style.color = 'rgb(112, 112, 112)';
		cssMenu.style.whiteSpace = 'nowrap';
		cssMenu.style.overflow = 'hidden';
		cssMenu.style.margin = '0px';
		this.addArrow(cssMenu);
		cssMenu.style.width = '192px';
		cssMenu.style.height = '15px';

		var arrow = cssMenu.getElementsByTagName('div')[0];
		arrow.style.cssFloat = 'right';
		container.appendChild(cssPanel);
	}

	container.appendChild(stylePanel);

	var colorPanel = this.createPanel();
	colorPanel.style.marginTop = '8px';
	colorPanel.style.borderTop = '1px solid #c0c0c0';
	colorPanel.style.paddingTop = '6px';
	colorPanel.style.paddingBottom = '6px';

	var fontMenu = this.addMenu('Helvetica', mxResources.get('fontFamily'), true, 'fontFamily', stylePanel);
	fontMenu.style.color = 'rgb(112, 112, 112)';
	fontMenu.style.whiteSpace = 'nowrap';
	fontMenu.style.overflow = 'hidden';
	fontMenu.style.margin = '0px';

	this.addArrow(fontMenu);
	fontMenu.style.width = '192px';
	fontMenu.style.height = '15px';

	// Workaround for offset in FF
	if (mxClient.IS_FF) {
		fontMenu.getElementsByTagName('div')[0].style.marginTop = '-18px';
	}

	var stylePanel2 = stylePanel.cloneNode(false);
	stylePanel2.style.marginLeft = '-3px';
	var fontStyleItems = this.addItems(['bold', 'italic', 'underline'], stylePanel2, true);
	fontStyleItems[0].setAttribute('title', mxResources.get('bold') + ' (' + this.editorUi.actions.get('bold').shortcut + ')');
	fontStyleItems[1].setAttribute('title', mxResources.get('italic') + ' (' + this.editorUi.actions.get('italic').shortcut + ')');
	fontStyleItems[2].setAttribute('title', mxResources.get('underline') + ' (' + this.editorUi.actions.get('underline').shortcut + ')');

	var verticalItem = this.addItems(['vertical'], stylePanel2, true)[0];

	if (mxClient.IS_QUIRKS) {
		mxUtils.br(container);
	}

	container.appendChild(stylePanel2);

	this.styleButtons(fontStyleItems);
	this.styleButtons([verticalItem]);

	var stylePanel3 = stylePanel.cloneNode(false);
	stylePanel3.style.marginLeft = '-3px';
	stylePanel3.style.paddingBottom = '0px';

	var left = this.addButton('geSprite-left', mxResources.get('left'),
		(graph.cellEditor.isContentEditing()) ?
			function () {
				document.execCommand('justifyleft', false, null);
			} : this.editorUi.menus.createStyleChangeFunction([mxConstants.STYLE_ALIGN], [mxConstants.ALIGN_LEFT]), stylePanel3);
	var center = this.addButton('geSprite-center', mxResources.get('center'),
		(graph.cellEditor.isContentEditing()) ?
			function () {
				document.execCommand('justifycenter', false, null);
			} : this.editorUi.menus.createStyleChangeFunction([mxConstants.STYLE_ALIGN], [mxConstants.ALIGN_CENTER]), stylePanel3);
	var right = this.addButton('geSprite-right', mxResources.get('right'),
		(graph.cellEditor.isContentEditing()) ?
			function () {
				document.execCommand('justifyright', false, null);
			} : this.editorUi.menus.createStyleChangeFunction([mxConstants.STYLE_ALIGN], [mxConstants.ALIGN_RIGHT]), stylePanel3);

	this.styleButtons([left, center, right]);

	if (graph.cellEditor.isContentEditing()) {
		var clear = this.addButton('geSprite-removeformat', mxResources.get('removeFormat'),
			function () {
				document.execCommand('removeformat', false, null);
			}, stylePanel2);
		this.styleButtons([clear]);
	}

	var top = this.addButton('geSprite-top', mxResources.get('top'),
		this.editorUi.menus.createStyleChangeFunction([mxConstants.STYLE_VERTICAL_ALIGN], [mxConstants.ALIGN_TOP]), stylePanel3);
	var middle = this.addButton('geSprite-middle', mxResources.get('middle'),
		this.editorUi.menus.createStyleChangeFunction([mxConstants.STYLE_VERTICAL_ALIGN], [mxConstants.ALIGN_MIDDLE]), stylePanel3);
	var bottom = this.addButton('geSprite-bottom', mxResources.get('bottom'),
		this.editorUi.menus.createStyleChangeFunction([mxConstants.STYLE_VERTICAL_ALIGN], [mxConstants.ALIGN_BOTTOM]), stylePanel3);

	this.styleButtons([top, middle, bottom]);

	if (mxClient.IS_QUIRKS) {
		mxUtils.br(container);
	}

	container.appendChild(stylePanel3);

	// Hack for updating UI state below based on current text selection
	// currentTable is the current selected DOM table updated below
	var sub, sup, full, tableWrapper, currentTable, tableCell, tableRow;

	if (graph.cellEditor.isContentEditing()) {
		top.style.display = 'none';
		middle.style.display = 'none';
		bottom.style.display = 'none';
		verticalItem.style.display = 'none';

		full = this.addButton('geSprite-justifyfull', null,
			function () {
				document.execCommand('justifyfull', false, null);
			}, stylePanel3);
		this.styleButtons([full,
			sub = this.addButton('geSprite-subscript', mxResources.get('subscript') + ' (Ctrl+,)',
				function () {
					document.execCommand('subscript', false, null);
				}, stylePanel3), sup = this.addButton('geSprite-superscript', mxResources.get('superscript') + ' (Ctrl+.)',
				function () {
					document.execCommand('superscript', false, null);
				}, stylePanel3)]);
		full.style.marginRight = '9px';

		var tmp = stylePanel3.cloneNode(false);
		tmp.style.paddingTop = '4px';
		var btns = [this.addButton('geSprite-orderedlist', mxResources.get('numberedList'),
			function () {
				document.execCommand('insertorderedlist', false, null);
			}, tmp),
			this.addButton('geSprite-unorderedlist', mxResources.get('bulletedList'),
				function () {
					document.execCommand('insertunorderedlist', false, null);
				}, tmp),
			this.addButton('geSprite-outdent', mxResources.get('decreaseIndent'),
				function () {
					document.execCommand('outdent', false, null);
				}, tmp),
			this.addButton('geSprite-indent', mxResources.get('increaseIndent'),
				function () {
					document.execCommand('indent', false, null);
				}, tmp),
			this.addButton('geSprite-code', mxResources.get('html'),
				function () {
					graph.cellEditor.toggleViewMode();
				}, tmp)];
		this.styleButtons(btns);
		btns[btns.length - 1].style.marginLeft = '9px';

		if (mxClient.IS_QUIRKS) {
			mxUtils.br(container);
			tmp.style.height = '40';
		}

		container.appendChild(tmp);
	}
	else {
		fontStyleItems[2].style.marginRight = '9px';
		right.style.marginRight = '9px';
	}

	// Label position
	var stylePanel4 = stylePanel.cloneNode(false);
	stylePanel4.style.marginLeft = '0px';
	stylePanel4.style.paddingTop = '8px';
	stylePanel4.style.paddingBottom = '4px';
	stylePanel4.style.fontWeight = 'normal';

	mxUtils.write(stylePanel4, mxResources.get('position'));

	// Adds label position options
	var positionSelect = document.createElement('select');
	positionSelect.style.position = 'absolute';
	positionSelect.style.right = '20px';
	positionSelect.style.width = '97px';
	positionSelect.style.marginTop = '-2px';

	var directions = ['topLeft', 'top', 'topRight', 'left', 'center', 'right', 'bottomLeft', 'bottom', 'bottomRight'];
	var lset = {
		'topLeft': [mxConstants.ALIGN_LEFT, mxConstants.ALIGN_TOP, mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_BOTTOM],
		'top': [mxConstants.ALIGN_CENTER, mxConstants.ALIGN_TOP, mxConstants.ALIGN_CENTER, mxConstants.ALIGN_BOTTOM],
		'topRight': [mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_TOP, mxConstants.ALIGN_LEFT, mxConstants.ALIGN_BOTTOM],
		'left': [mxConstants.ALIGN_LEFT, mxConstants.ALIGN_MIDDLE, mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_MIDDLE],
		'center': [mxConstants.ALIGN_CENTER, mxConstants.ALIGN_MIDDLE, mxConstants.ALIGN_CENTER, mxConstants.ALIGN_MIDDLE],
		'right': [mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_MIDDLE, mxConstants.ALIGN_LEFT, mxConstants.ALIGN_MIDDLE],
		'bottomLeft': [mxConstants.ALIGN_LEFT, mxConstants.ALIGN_BOTTOM, mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_TOP],
		'bottom': [mxConstants.ALIGN_CENTER, mxConstants.ALIGN_BOTTOM, mxConstants.ALIGN_CENTER, mxConstants.ALIGN_TOP],
		'bottomRight': [mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_BOTTOM, mxConstants.ALIGN_LEFT, mxConstants.ALIGN_TOP]
	};

	for (var i = 0; i < directions.length; i++) {
		var positionOption = document.createElement('option');
		positionOption.setAttribute('value', directions[i]);
		mxUtils.write(positionOption, mxResources.get(directions[i]));
		positionSelect.appendChild(positionOption);
	}

	stylePanel4.appendChild(positionSelect);

	// Writing direction
	var stylePanel5 = stylePanel.cloneNode(false);
	stylePanel5.style.marginLeft = '0px';
	stylePanel5.style.paddingTop = '4px';
	stylePanel5.style.paddingBottom = '4px';
	stylePanel5.style.fontWeight = 'normal';

	mxUtils.write(stylePanel5, mxResources.get('writingDirection'));

	// Adds writing direction options
	// LATER: Handle reselect of same option in all selects (change event
	// is not fired for same option so have opened state on click) and
	// handle multiple different styles for current selection
	var dirSelect = document.createElement('select');
	dirSelect.style.position = 'absolute';
	dirSelect.style.right = '20px';
	dirSelect.style.width = '97px';
	dirSelect.style.marginTop = '-2px';

	// NOTE: For automatic we use the value null since automatic
	// requires the text to be non formatted and non-wrapped
	var dirs = ['automatic', 'leftToRight', 'rightToLeft'];
	var dirSet = {
		'automatic': null,
		'leftToRight': mxConstants.TEXT_DIRECTION_LTR,
		'rightToLeft': mxConstants.TEXT_DIRECTION_RTL
	};

	for (var i = 0; i < dirs.length; i++) {
		var dirOption = document.createElement('option');
		dirOption.setAttribute('value', dirs[i]);
		mxUtils.write(dirOption, mxResources.get(dirs[i]));
		dirSelect.appendChild(dirOption);
	}

	stylePanel5.appendChild(dirSelect);

	if (!graph.isEditing()) {
		container.appendChild(stylePanel4);

		mxEvent.addListener(positionSelect, 'change', function (evt) {
			graph.getModel().beginUpdate();
			try {
				var vals = lset[positionSelect.value];

				if (vals != null) {					graph.setCellStyles(mxConstants.STYLE_LABEL_POSITION, vals[0], graph.getSelectionCells());
					graph.setCellStyles(mxConstants.STYLE_VERTICAL_LABEL_POSITION, vals[1], graph.getSelectionCells());
					graph.setCellStyles(mxConstants.STYLE_ALIGN, vals[2], graph.getSelectionCells());
					graph.setCellStyles(mxConstants.STYLE_VERTICAL_ALIGN, vals[3], graph.getSelectionCells());
				}
			}
			finally {
				graph.getModel().endUpdate();
			}

			mxEvent.consume(evt);
		});

		// LATER: Update dir in text editor while editing and update style with label
		// NOTE: The tricky part is handling and passing on the auto value
		container.appendChild(stylePanel5);

		mxEvent.addListener(dirSelect, 'change', function (evt) {
			graph.setCellStyles(mxConstants.STYLE_TEXT_DIRECTION, dirSet[dirSelect.value], graph.getSelectionCells());
			mxEvent.consume(evt);
		});
	}

	// Font size
	var input = document.createElement('input');
	input.style.textAlign = 'right';
	input.style.marginTop = '4px';

	if (!mxClient.IS_QUIRKS) {
		input.style.position = 'absolute';
		input.style.right = '32px';
	}

	input.style.width = '46px';
	input.style.height = (mxClient.IS_QUIRKS) ? '21px' : '17px';
	stylePanel2.appendChild(input);

	// Workaround for font size 4 if no text is selected is update font size below
	// after first character was entered (as the font element is lazy created)
	var pendingFontSize = null;

	var inputUpdate = this.installInputHandler(input, mxConstants.STYLE_FONTSIZE, Menus.prototype.defaultFontSize, 1, 999, ' pt',
		function (fontsize) {
			pendingFontSize = fontsize;

			// Workaround for can't set font size in px is to change font size afterwards
			document.execCommand('fontSize', false, '4');
			var elts = graph.cellEditor.textarea.getElementsByTagName('font');

			for (var i = 0; i < elts.length; i++) {
				if (elts[i].getAttribute('size') == '4') {
					elts[i].removeAttribute('size');
					elts[i].style.fontSize = pendingFontSize + 'px';

					// Overrides fontSize in input with the one just assigned as a workaround
					// for potential fontSize values of parent elements that don't match
					window.setTimeout(function () {
						input.value = pendingFontSize + ' pt';
						pendingFontSize = null;
					}, 0);

					break;
				}
			}
		}, true);

	var stepper = this.createStepper(input, inputUpdate, 1, 10, true, Menus.prototype.defaultFontSize);
	stepper.style.display = input.style.display;
	stepper.style.marginTop = '4px';

	if (!mxClient.IS_QUIRKS) {
		stepper.style.right = '20px';
	}

	stylePanel2.appendChild(stepper);

	var arrow = fontMenu.getElementsByTagName('div')[0];
	arrow.style.cssFloat = 'right';

	var bgColorApply = null;
	var currentBgColor = '#ffffff';

	var fontColorApply = null;
	var currentFontColor = '#000000';

	var bgPanel = (graph.cellEditor.isContentEditing()) ? this.createColorOption(mxResources.get('backgroundColor'), function () {
			return currentBgColor;
		}, function (color) {
			document.execCommand('backcolor', false, (color != mxConstants.NONE) ? color : 'transparent');
		}, '#ffffff',
		{
			install: function (apply) {
				bgColorApply = apply;
			},
			destroy: function () {
				bgColorApply = null;
			}
		}, null, true) : this.createCellColorOption(mxResources.get('backgroundColor'), mxConstants.STYLE_LABEL_BACKGROUNDCOLOR, '#ffffff');
	bgPanel.style.fontWeight = 'bold';

	var borderPanel = this.createCellColorOption(mxResources.get('borderColor'), mxConstants.STYLE_LABEL_BORDERCOLOR, '#000000');
	borderPanel.style.fontWeight = 'bold';

	var panel = (graph.cellEditor.isContentEditing()) ? this.createColorOption(mxResources.get('fontColor'), function () {
			return currentFontColor;
		}, function (color) {
			document.execCommand('forecolor', false, (color != mxConstants.NONE) ? color : 'transparent');
		}, '#000000',
		{
			install: function (apply) {
				fontColorApply = apply;
			},
			destroy: function () {
				fontColorApply = null;
			}
		}, null, true) : this.createCellColorOption(mxResources.get('fontColor'), mxConstants.STYLE_FONTCOLOR, '#000000', function (color) {
		if (color == null || color == mxConstants.NONE) {
			bgPanel.style.display = 'none';
		}
		else {
			bgPanel.style.display = '';
		}

		borderPanel.style.display = bgPanel.style.display;
	}, function (color) {
		if (color == null || color == mxConstants.NONE) {
			graph.setCellStyles(mxConstants.STYLE_NOLABEL, '1', graph.getSelectionCells());
		}
		else {
			graph.setCellStyles(mxConstants.STYLE_NOLABEL, null, graph.getSelectionCells());
		}
	});
	panel.style.fontWeight = 'bold';
	colorPanel.appendChild(panel);

	var cells = this.editorUi.editor.graph.getSelectionCells();
	const widgetConfig = this.editorUi.designer.store.widgetsManager.get(cells[0])
	const isIconShape = ss.style.shape == 'image' && ss.style[mxConstants.STYLE_IMAGE_CONTENT_TYPE] == 'icon'

	if (isIconShape || widgetConfig?.type == 'report') {
		var iconColorPanel = this.createCellColorOption(
			i18n('Icon color'),
			mxConstants.STYLE_ICON_COLOR,
			'#FFFFFF');

		iconColorPanel.style.fontWeight = 'bold';
		colorPanel.appendChild(iconColorPanel);
	}

	colorPanel.appendChild(bgPanel);

	if (!graph.cellEditor.isContentEditing()) {
		colorPanel.appendChild(borderPanel);
	}

	container.appendChild(colorPanel);

	var extraPanel = this.createPanel();
	extraPanel.style.paddingTop = '2px';
	extraPanel.style.paddingBottom = '4px';

	// LATER: Fix toggle using '' instead of 'null'
	var wwOpt = this.createCellOption(mxResources.get('wordWrap'), mxConstants.STYLE_WHITE_SPACE, null, 'wrap', 'null', null, null, true);
	wwOpt.style.fontWeight = 'bold';

	// Word wrap in edge labels only supported via labelWidth style
	if (!ss.containsLabel && !ss.autoSize && ss.edges.length == 0) {
		extraPanel.appendChild(wwOpt);
	}

	// Delegates switch of style to formattedText action as it also convertes newlines
	var htmlOpt = this.createCellOption(mxResources.get('formattedText'), 'html', '0',
		null, null, null, ui.actions.get('formattedText'));
	htmlOpt.style.fontWeight = 'bold';
	extraPanel.appendChild(htmlOpt);

	var spacingPanel = this.createPanel();
	spacingPanel.style.paddingTop = '10px';
	spacingPanel.style.paddingBottom = '28px';
	spacingPanel.style.fontWeight = 'normal';

	var span = document.createElement('div');
	span.style.position = 'absolute';
	span.style.width = '70px';
	span.style.marginTop = '0px';
	span.style.fontWeight = 'bold';
	mxUtils.write(span, mxResources.get('spacing'));
	spacingPanel.appendChild(span);

	var topUpdate, globalUpdate, leftUpdate, bottomUpdate, rightUpdate;
	var topSpacing = this.addUnitInput(spacingPanel, 'pt', 91, 44, function () {
		topUpdate.apply(this, arguments);
	});
	var globalSpacing = this.addUnitInput(spacingPanel, 'pt', 20, 44, function () {
		globalUpdate.apply(this, arguments);
	});

	mxUtils.br(spacingPanel);
	this.addLabel(spacingPanel, mxResources.get('top'), 91);
	this.addLabel(spacingPanel, mxResources.get('global'), 20);
	mxUtils.br(spacingPanel);
	mxUtils.br(spacingPanel);

	var leftSpacing = this.addUnitInput(spacingPanel, 'pt', 162, 44, function () {
		leftUpdate.apply(this, arguments);
	});
	var bottomSpacing = this.addUnitInput(spacingPanel, 'pt', 91, 44, function () {
		bottomUpdate.apply(this, arguments);
	});
	var rightSpacing = this.addUnitInput(spacingPanel, 'pt', 20, 44, function () {
		rightUpdate.apply(this, arguments);
	});

	mxUtils.br(spacingPanel);
	this.addLabel(spacingPanel, mxResources.get('left'), 162);
	this.addLabel(spacingPanel, mxResources.get('bottom'), 91);
	this.addLabel(spacingPanel, mxResources.get('right'), 20);

	if (!graph.cellEditor.isContentEditing()) {
		container.appendChild(extraPanel);
		container.appendChild(this.createRelativeOption(mxResources.get('opacity'), mxConstants.STYLE_TEXT_OPACITY));
		container.appendChild(spacingPanel);
	}
	else {
		var selState = null;
		var lineHeightInput = null;

		container.appendChild(this.createRelativeOption(mxResources.get('lineheight'), null, null, function (input) {
			var value = (input.value == '') ? 120 : parseInt(input.value);
			value = Math.max(0, (isNaN(value)) ? 120 : value);

			if (selState != null) {
				graph.cellEditor.restoreSelection(selState);
				selState = null;
			}

			var selectedElement = graph.getSelectedElement();
			var node = selectedElement;

			while (node != null && node.nodeType != mxConstants.NODETYPE_ELEMENT) {
				node = node.parentNode;
			}

			if (node != null && node == graph.cellEditor.textarea && graph.cellEditor.textarea.firstChild != null) {
				if (graph.cellEditor.textarea.firstChild.nodeName != 'P') {
					graph.cellEditor.textarea.innerHTML = '<p>' + graph.cellEditor.textarea.innerHTML + '</p>';
				}

				node = graph.cellEditor.textarea.firstChild;
			}

			if (node != null && node != graph.cellEditor.textarea) {
				node.style.lineHeight = value + '%';
			}

			input.value = value + ' %';
		}, function (input) {
			// Used in CSS handler to update current value
			lineHeightInput = input;

			// KNOWN: Arrow up/down clear selection text in quirks/IE 8
			// Text size via arrow button limits to 16 in IE11. Why?
			mxEvent.addListener(input, 'mousedown', function () {
				selState = graph.cellEditor.saveSelection();
			});

			mxEvent.addListener(input, 'touchstart', function () {
				selState = graph.cellEditor.saveSelection();
			});

			input.value = '120 %';
		}));

		var insertPanel = stylePanel.cloneNode(false);
		insertPanel.style.paddingLeft = '0px';
		var insertBtns = this.addItems(['link', 'image'], insertPanel, true);

		var btns = [
			this.addButton('geSprite-horizontalrule', mxResources.get('insertHorizontalRule'),
				function () {
					document.execCommand('inserthorizontalrule', false, null);
				}, insertPanel),
			this.addMenuFunctionInContainer(insertPanel, 'geSprite-table', mxResources.get('table'), false, mxUtils.bind(this, function (menu) {
				this.editorUi.menus.addInsertTableItem(menu);
			}))];
		this.styleButtons(insertBtns);
		this.styleButtons(btns);

		var wrapper2 = this.createPanel();
		wrapper2.style.paddingTop = '10px';
		wrapper2.style.paddingBottom = '10px';
		wrapper2.appendChild(this.createTitle(mxResources.get('insert')));
		wrapper2.appendChild(insertPanel);
		container.appendChild(wrapper2);

		if (mxClient.IS_QUIRKS) {
			wrapper2.style.height = '70';
		}

		var tablePanel = stylePanel.cloneNode(false);
		tablePanel.style.paddingLeft = '0px';

		var btns = [
			this.addButton('geSprite-insertcolumnbefore', mxResources.get('insertColumnBefore'),
				function () {
					try {
						if (currentTable != null) {
							graph.selectNode(graph.insertColumn(currentTable, (tableCell != null) ? tableCell.cellIndex : 0));
						}
					}
					catch (e) {
						alert(e);
					}
				}, tablePanel),
			this.addButton('geSprite-insertcolumnafter', mxResources.get('insertColumnAfter'),
				function () {
					try {
						if (currentTable != null) {
							graph.selectNode(graph.insertColumn(currentTable, (tableCell != null) ? tableCell.cellIndex + 1 : -1));
						}
					}
					catch (e) {
						alert(e);
					}
				}, tablePanel),
			this.addButton('geSprite-deletecolumn', mxResources.get('deleteColumn'),
				function () {
					try {
						if (currentTable != null && tableCell != null) {
							graph.deleteColumn(currentTable, tableCell.cellIndex);
						}
					}
					catch (e) {
						alert(e);
					}
				}, tablePanel),
			this.addButton('geSprite-insertrowbefore', mxResources.get('insertRowBefore'),
				function () {
					try {
						if (currentTable != null && tableRow != null) {
							graph.selectNode(graph.insertRow(currentTable, tableRow.sectionRowIndex));
						}
					}
					catch (e) {
						alert(e);
					}
				}, tablePanel),
			this.addButton('geSprite-insertrowafter', mxResources.get('insertRowAfter'),
				function () {
					try {
						if (currentTable != null && tableRow != null) {
							graph.selectNode(graph.insertRow(currentTable, tableRow.sectionRowIndex + 1));
						}
					}
					catch (e) {
						alert(e);
					}
				}, tablePanel),
			this.addButton('geSprite-deleterow', mxResources.get('deleteRow'),
				function () {
					try {
						if (currentTable != null && tableRow != null) {
							graph.deleteRow(currentTable, tableRow.sectionRowIndex);
						}
					}
					catch (e) {
						alert(e);
					}
				}, tablePanel)];
		this.styleButtons(btns);
		btns[2].style.marginRight = '9px';

		var wrapper3 = this.createPanel();
		wrapper3.style.paddingTop = '10px';
		wrapper3.style.paddingBottom = '10px';
		wrapper3.appendChild(this.createTitle(mxResources.get('table')));
		wrapper3.appendChild(tablePanel);

		if (mxClient.IS_QUIRKS) {
			mxUtils.br(container);
			wrapper3.style.height = '70';
		}

		var tablePanel2 = stylePanel.cloneNode(false);
		tablePanel2.style.paddingLeft = '0px';

		var btns = [
			this.addButton('geSprite-strokecolor', mxResources.get('borderColor'),
				mxUtils.bind(this, function () {
					if (currentTable != null) {
						// Converts rgb(r,g,b) values
						var color = currentTable.style.borderColor.replace(
							/\brgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g,
							function ($0, $1, $2, $3) {
								return "#" + ("0" + Number($1).toString(16)).substr(-2) + ("0" + Number($2).toString(16)).substr(-2) + ("0" + Number($3).toString(16)).substr(-2);
							});
						this.editorUi.pickColor(color, function (newColor) {
							if (newColor == null || newColor == mxConstants.NONE) {
								currentTable.removeAttribute('border');
								currentTable.style.border = '';
								currentTable.style.borderCollapse = '';
							}
							else {
								currentTable.setAttribute('border', '1');
								currentTable.style.border = '1px solid ' + newColor;
								currentTable.style.borderCollapse = 'collapse';
							}
						});
					}
				}), tablePanel2),
			this.addButton('geSprite-fillcolor', mxResources.get('backgroundColor'),
				mxUtils.bind(this, function () {
					// Converts rgb(r,g,b) values
					if (currentTable != null) {
						var color = currentTable.style.backgroundColor.replace(
							/\brgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g,
							function ($0, $1, $2, $3) {
								return "#" + ("0" + Number($1).toString(16)).substr(-2) + ("0" + Number($2).toString(16)).substr(-2) + ("0" + Number($3).toString(16)).substr(-2);
							});
						this.editorUi.pickColor(color, function (newColor) {
							if (newColor == null || newColor == mxConstants.NONE) {
								currentTable.style.backgroundColor = '';
							}
							else {
								currentTable.style.backgroundColor = newColor;
							}
						});
					}
				}), tablePanel2),
			this.addButton('geSprite-fit', mxResources.get('spacing'),
				function () {
					if (currentTable != null) {
						var value = currentTable.getAttribute('cellPadding') || 0;

						var dlg = new FilenameDialog(ui, value, mxResources.get('apply'), mxUtils.bind(this, function (newValue) {
							if (newValue != null && newValue.length > 0) {
								currentTable.setAttribute('cellPadding', newValue);
							}
							else {
								currentTable.removeAttribute('cellPadding');
							}
						}), mxResources.get('spacing'));
						ui.showDialog(dlg.container, 300, 80, true, true);
						dlg.init();
					}
				}, tablePanel2),
			this.addButton('geSprite-left', mxResources.get('left'),
				function () {
					if (currentTable != null) {
						currentTable.setAttribute('align', 'left');
					}
				}, tablePanel2),
			this.addButton('geSprite-center', mxResources.get('center'),
				function () {
					if (currentTable != null) {
						currentTable.setAttribute('align', 'center');
					}
				}, tablePanel2),
			this.addButton('geSprite-right', mxResources.get('right'),
				function () {
					if (currentTable != null) {
						currentTable.setAttribute('align', 'right');
					}
				}, tablePanel2)];
		this.styleButtons(btns);
		btns[2].style.marginRight = '9px';

		if (mxClient.IS_QUIRKS) {
			mxUtils.br(wrapper3);
			mxUtils.br(wrapper3);
		}

		wrapper3.appendChild(tablePanel2);
		container.appendChild(wrapper3);

		tableWrapper = wrapper3;
	}

	function setSelected(elt, selected) {
		if (mxClient.IS_IE && (mxClient.IS_QUIRKS || document.documentMode < 10)) {
			elt.style.filter = (selected) ? 'progid:DXImageTransform.Microsoft.Gradient(' +
				'StartColorStr=\'#c5ecff\', EndColorStr=\'#87d4fb\', GradientType=0)' : '';
		}
		else {
			elt.style.backgroundImage = (selected) ? 'linear-gradient(#c5ecff 0px,#87d4fb 100%)' : '';
		}
	};

	var listener = mxUtils.bind(this, function (sender, evt, force) {
		ss = this.format.getSelectionState();
		var fontStyle = mxUtils.getValue(ss.style, mxConstants.STYLE_FONTSTYLE, 0);
		setSelected(fontStyleItems[0], (fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD);
		setSelected(fontStyleItems[1], (fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC);
		setSelected(fontStyleItems[2], (fontStyle & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE);
		fontMenu.firstChild.nodeValue = mxUtils.htmlEntities(mxUtils.getValue(ss.style, mxConstants.STYLE_FONTFAMILY, Menus.prototype.defaultFont));

		setSelected(verticalItem, mxUtils.getValue(ss.style, mxConstants.STYLE_HORIZONTAL, '1') == '0');

		if (force || document.activeElement != input) {
			var tmp = parseFloat(mxUtils.getValue(ss.style, mxConstants.STYLE_FONTSIZE, Menus.prototype.defaultFontSize));
			input.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		var align = mxUtils.getValue(ss.style, mxConstants.STYLE_ALIGN, mxConstants.ALIGN_CENTER);
		setSelected(left, align == mxConstants.ALIGN_LEFT);
		setSelected(center, align == mxConstants.ALIGN_CENTER);
		setSelected(right, align == mxConstants.ALIGN_RIGHT);

		var valign = mxUtils.getValue(ss.style, mxConstants.STYLE_VERTICAL_ALIGN, mxConstants.ALIGN_MIDDLE);
		setSelected(top, valign == mxConstants.ALIGN_TOP);
		setSelected(middle, valign == mxConstants.ALIGN_MIDDLE);
		setSelected(bottom, valign == mxConstants.ALIGN_BOTTOM);

		var pos = mxUtils.getValue(ss.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER);
		var vpos = mxUtils.getValue(ss.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE);

		if (pos == mxConstants.ALIGN_LEFT && vpos == mxConstants.ALIGN_TOP) {
			positionSelect.value = 'topLeft';
		}
		else if (pos == mxConstants.ALIGN_CENTER && vpos == mxConstants.ALIGN_TOP) {
			positionSelect.value = 'top';
		}
		else if (pos == mxConstants.ALIGN_RIGHT && vpos == mxConstants.ALIGN_TOP) {
			positionSelect.value = 'topRight';
		}
		else if (pos == mxConstants.ALIGN_LEFT && vpos == mxConstants.ALIGN_BOTTOM) {
			positionSelect.value = 'bottomLeft';
		}
		else if (pos == mxConstants.ALIGN_CENTER && vpos == mxConstants.ALIGN_BOTTOM) {
			positionSelect.value = 'bottom';
		}
		else if (pos == mxConstants.ALIGN_RIGHT && vpos == mxConstants.ALIGN_BOTTOM) {
			positionSelect.value = 'bottomRight';
		}
		else if (pos == mxConstants.ALIGN_LEFT) {
			positionSelect.value = 'left';
		}
		else if (pos == mxConstants.ALIGN_RIGHT) {
			positionSelect.value = 'right';
		}
		else {
			positionSelect.value = 'center';
		}

		var dir = mxUtils.getValue(ss.style, mxConstants.STYLE_TEXT_DIRECTION, mxConstants.DEFAULT_TEXT_DIRECTION);

		if (dir == mxConstants.TEXT_DIRECTION_RTL) {
			dirSelect.value = 'rightToLeft';
		}
		else if (dir == mxConstants.TEXT_DIRECTION_LTR) {
			dirSelect.value = 'leftToRight';
		}
		else if (dir == mxConstants.TEXT_DIRECTION_AUTO) {
			dirSelect.value = 'automatic';
		}

		if (force || document.activeElement != globalSpacing) {
			var tmp = parseFloat(mxUtils.getValue(ss.style, mxConstants.STYLE_SPACING, 2));
			globalSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != topSpacing) {
			var tmp = parseFloat(mxUtils.getValue(ss.style, mxConstants.STYLE_SPACING_TOP, 0));
			topSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != rightSpacing) {
			var tmp = parseFloat(mxUtils.getValue(ss.style, mxConstants.STYLE_SPACING_RIGHT, 0));
			rightSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != bottomSpacing) {
			var tmp = parseFloat(mxUtils.getValue(ss.style, mxConstants.STYLE_SPACING_BOTTOM, 0));
			bottomSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != leftSpacing) {
			var tmp = parseFloat(mxUtils.getValue(ss.style, mxConstants.STYLE_SPACING_LEFT, 0));
			leftSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}
	});

	globalUpdate = this.installInputHandler(globalSpacing, mxConstants.STYLE_SPACING, 2, -999, 999, ' pt');
	topUpdate = this.installInputHandler(topSpacing, mxConstants.STYLE_SPACING_TOP, 0, -999, 999, ' pt');
	rightUpdate = this.installInputHandler(rightSpacing, mxConstants.STYLE_SPACING_RIGHT, 0, -999, 999, ' pt');
	bottomUpdate = this.installInputHandler(bottomSpacing, mxConstants.STYLE_SPACING_BOTTOM, 0, -999, 999, ' pt');
	leftUpdate = this.installInputHandler(leftSpacing, mxConstants.STYLE_SPACING_LEFT, 0, -999, 999, ' pt');

	this.addKeyHandler(input, listener);
	this.addKeyHandler(globalSpacing, listener);
	this.addKeyHandler(topSpacing, listener);
	this.addKeyHandler(rightSpacing, listener);
	this.addKeyHandler(bottomSpacing, listener);
	this.addKeyHandler(leftSpacing, listener);

	graph.getModel().addListener(mxEvent.CHANGE, listener);
	this.listeners.push({
		destroy: function () {
			graph.getModel().removeListener(listener);
		}
	});
	listener();

	if (graph.cellEditor.isContentEditing()) {
		var updating = false;

		var updateCssHandler = function () {
			if (!updating) {
				updating = true;

				window.setTimeout(function () {
					var selectedElement = graph.getSelectedElement();
					var node = selectedElement;

					while (node != null && node.nodeType != mxConstants.NODETYPE_ELEMENT) {
						node = node.parentNode;
					}

					if (node != null) {
						var css = mxUtils.getCurrentStyle(node);

						if (css != null) {
							setSelected(fontStyleItems[0], css.fontWeight == 'bold' || graph.getParentByName(node, 'B', graph.cellEditor.textarea) != null);
							setSelected(fontStyleItems[1], css.fontStyle == 'italic' || graph.getParentByName(node, 'I', graph.cellEditor.textarea) != null);
							setSelected(fontStyleItems[2], graph.getParentByName(node, 'U', graph.cellEditor.textarea) != null);
							setSelected(left, css.textAlign == 'left');
							setSelected(center, css.textAlign == 'center');
							setSelected(right, css.textAlign == 'right');
							setSelected(full, css.textAlign == 'justify');
							setSelected(sup, graph.getParentByName(node, 'SUP', graph.cellEditor.textarea) != null);
							setSelected(sub, graph.getParentByName(node, 'SUB', graph.cellEditor.textarea) != null);

							currentTable = graph.getParentByName(node, 'TABLE', graph.cellEditor.textarea);
							tableRow = (currentTable == null) ? null : graph.getParentByName(node, 'TR', currentTable);
							tableCell = (currentTable == null) ? null : graph.getParentByName(node, 'TD', currentTable);
							tableWrapper.style.display = (currentTable != null) ? '' : 'none';

							if (document.activeElement != input) {
								if (node.nodeName == 'FONT' && node.getAttribute('size') == '4' &&
									pendingFontSize != null) {
									node.removeAttribute('size');
									node.style.fontSize = pendingFontSize + 'px';
									pendingFontSize = null;
								}
								else {
									input.value = parseFloat(css.fontSize) + ' pt';
								}

								var tmp = node.style.lineHeight || css.lineHeight;
								var lh = parseFloat(tmp);

								if (tmp.substring(tmp.length - 2) == 'px') {
									lh = lh / parseFloat(css.fontSize);
								}

								if (tmp.substring(tmp.length - 1) != '%') {
									lh *= 100;
								}

								lineHeightInput.value = lh + ' %';
							}

							// Converts rgb(r,g,b) values
							var color = css.color.replace(
								/\brgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g,
								function ($0, $1, $2, $3) {
									return "#" + ("0" + Number($1).toString(16)).substr(-2) + ("0" + Number($2).toString(16)).substr(-2) + ("0" + Number($3).toString(16)).substr(-2);
								});

							var color2 = css.backgroundColor.replace(
								/\brgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g,
								function ($0, $1, $2, $3) {
									return "#" + ("0" + Number($1).toString(16)).substr(-2) + ("0" + Number($2).toString(16)).substr(-2) + ("0" + Number($3).toString(16)).substr(-2);
								});

							// Updates the color picker for the current font
							if (fontColorApply != null) {
								if (color.charAt(0) == '#') {
									currentFontColor = color;
								}
								else {
									currentFontColor = '#000000';
								}

								fontColorApply(currentFontColor, true);
							}

							if (bgColorApply != null) {
								if (color2.charAt(0) == '#') {
									currentBgColor = color2;
								}
								else {
									currentBgColor = null;
								}

								bgColorApply(currentBgColor, true);
							}

							// Workaround for firstChild is null or not an object
							// in the log which seems to be IE8- only / 29.01.15
							if (fontMenu.firstChild != null) {
								// Strips leading and trailing quotes
								var ff = css.fontFamily;

								if (ff.charAt(0) == '\'') {
									ff = ff.substring(1);
								}

								if (ff.charAt(ff.length - 1) == '\'') {
									ff = ff.substring(0, ff.length - 1);
								}

								fontMenu.firstChild.nodeValue = ff;
							}
						}
					}

					updating = false;
				}, 0);
			}
		};

		mxEvent.addListener(graph.cellEditor.textarea, 'input', updateCssHandler)
		mxEvent.addListener(graph.cellEditor.textarea, 'touchend', updateCssHandler);
		mxEvent.addListener(graph.cellEditor.textarea, 'mouseup', updateCssHandler);
		mxEvent.addListener(graph.cellEditor.textarea, 'keyup', updateCssHandler);
		this.listeners.push({
			destroy: function () {
				// No need to remove listener since textarea is destroyed after edit
			}
		});
		updateCssHandler();
	}

	return container;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
window.StyleFormatPanel = function (format, editorUi, container,anyHtmlContainerCells) {
	BaseFormatPanel.call(this, format, editorUi, container, anyHtmlContainerCells);
	this.init();
};

mxUtils.extend(StyleFormatPanel, BaseFormatPanel);

/**
 * Adds the label menu items to the given menu and parent.
 */
StyleFormatPanel.prototype.init = function () {
	var ui = this.editorUi;
	var editor = ui.editor;

	if(!editor)
		return;

	var graph = editor.graph;
	var ss = this.format.getSelectionState();

	if ((!ss.containsImage || ss.style.shape == 'image') && ui.mode != 'service') {
		this.container.appendChild(this.addFill(this.createPanel()));
	}

	var opacityPanel = this.createRelativeOption(mxResources.get('opacity'), mxConstants.STYLE_OPACITY, 41);
	opacityPanel.style.paddingTop = '8px';
	opacityPanel.style.paddingBottom = '8px';
	this.container.appendChild(opacityPanel);

	this.container.appendChild(this.addStroke(this.createPanel()));

	if(!this.anyHtmlContainerCells) {
		this.container.appendChild(this.addEffects(this.createPanel()));
		var opsPanel = this.addEditOps(this.createPanel());

		if (opsPanel.firstChild != null) {
			mxUtils.br(opsPanel);
		}

		//this.container.appendChild(this.addStyleOps(opsPanel));
		this.container.appendChild(opsPanel);
	}
	if (this.editorUi.config?.mode === 'application') {
		this.container.appendChild(this.addAssetGroupContainer(this.createPanel()));
	}
};

/**
 * Adds the label menu items to the given menu and parent.
 */
StyleFormatPanel.prototype.addEditOps = function (div) {
	var ss = this.format.getSelectionState();
	var btn = null;

	if (this.editorUi.editor.graph.getSelectionCount() == 1) {
		btn = mxUtils.button(mxResources.get('editStyle'), mxUtils.bind(this, function (evt) {
			this.editorUi.actions.get('editStyle').funct();
		}));

		btn.setAttribute('title', mxResources.get('editStyle') + ' (' + this.editorUi.actions.get('editStyle').shortcut + ')');
		btn.style.width = '202px';
		btn.style.marginBottom = '2px';

		//div.appendChild(btn);
	}

	if (ss.image) {
		// var setImageButton = $( '<input type="button" value="' + lang.presentation.designer.SET_AN_IMAGE + '" class="k-button k-primary" />' );
		// div.appendChild(setImageButton[0]);

		var panelRow = $(
			'<div class="panel-row">' +
			// '<div class="label">' + i18n('Background image') + '</div>' +
			'<div class="form-element buttons-list">' +
			'<input type="button" value="' + i18n('Set Image') + '" class="k-button k-primary _select" />' +
			'<input type="button" class="k-button _clear" value="' + i18n('Clear image') + '"/>' +
			'</div>' +
			'</div>');
		div.appendChild(panelRow[0]);

		$('._select', panelRow).click(() => {
			let cell = ss.vertices[0]
			this.editorUi.actions.get('set-image').funct(cell)
		});

		$('._clear', panelRow).click($.proxy(function () {
			var graph = this.format.editorUi.editor.graph;
			var cells = graph.getSelectionCells();
			var cell = graph.getSelectionCell();
			graph.getModel().beginUpdate();
			try {
				graph.setCellStyles(mxConstants.STYLE_IMAGE_CONTENT_TYPE, 'icon', cells);
				graph.setCellStyles(mxConstants.STYLE_IMAGE_ICONS_PACK, 'glyphicons', cells);
				if(cell.customData) {
					if (cell.customData.type === 'ROOT') {
						graph.setCellStyles(mxConstants.STYLE_IMAGE, 'home', cells);
					} else {
						graph.setCellStyles(mxConstants.STYLE_IMAGE, 'file', cells);
					}
				}else{
					const dataSource = graph.designer.store.dataSourcesManager.get(cell)
					if(dataSource.type == 'asset'){
						graph.setCellStyles(mxConstants.STYLE_IMAGE, Sidebar.prototype.defaultAssetIcon, cells);
					}else if(dataSource.type == 'assetGroup'){
						graph.setCellStyles(mxConstants.STYLE_IMAGE, Sidebar.prototype.defaultAssetGroupIcon, cells);
					}
				}
			}
			finally {
				graph.getModel().endUpdate();
			}
		}, this));

		var checkCellForImage = function (cell) {
			if (!cell.style || cell.style.indexOf('image') != -1) {
				$('._clear', panelRow).removeAttr("disabled");
			} else {
				$('._clear', panelRow).attr("disabled", "disabled");
			}
		}

		var onCellImageChanged = function (graphModel, ev) {
			var change = ev.properties.changes[0];
			if (!(change instanceof mxStyleChange))
				return;

			checkCellForImage(change.cell);
		}

		this.editorUi.editor.graph.getModel().addListener(mxEvent.CHANGE, $.proxy(onCellImageChanged, this));
		checkCellForImage(this.editorUi.editor.graph.getSelectionCell());
	}

	return div;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
StyleFormatPanel.prototype.addFill = function (container) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;
	var ss = this.format.getSelectionState();
	container.style.paddingTop = '6px';
	container.style.paddingBottom = '6px';

	// Adds gradient direction option
	var gradientSelect = document.createElement('select');
	gradientSelect.style.position = 'absolute';
	gradientSelect.style.marginTop = '-2px';
	gradientSelect.style.right = (mxClient.IS_QUIRKS) ? '52px' : '72px';
	gradientSelect.style.width = '70px';

	// Stops events from bubbling to color option event handler
	mxEvent.addListener(gradientSelect, 'click', function (evt) {
		mxEvent.consume(evt);
	});

	var gradientPanel = this.createCellColorOption(mxResources.get('gradient'), mxConstants.STYLE_GRADIENTCOLOR, '#ffffff', function (color) {
		if (color == null || color == mxConstants.NONE) {
			gradientSelect.style.display = 'none';
		}
		else {
			gradientSelect.style.display = '';
		}
	});

	var fillKey = (ss.style.shape == 'image') ? mxConstants.STYLE_IMAGE_BACKGROUND : mxConstants.STYLE_FILLCOLOR;

	var fillPanel = this.createCellColorOption(mxResources.get('backgroundColor'), fillKey, '#FFFFFF');
	fillPanel.style.fontWeight = 'bold';

	var tmpColor = mxUtils.getValue(ss.style, fillKey, null);
	gradientPanel.style.display = (tmpColor != null && tmpColor != mxConstants.NONE &&
		ss.fill && ss.style.shape != 'image') ? '' : 'none';

	var directions = [mxConstants.DIRECTION_NORTH, mxConstants.DIRECTION_EAST,
		mxConstants.DIRECTION_SOUTH, mxConstants.DIRECTION_WEST];

	for (var i = 0; i < directions.length; i++) {
		var gradientOption = document.createElement('option');
		gradientOption.setAttribute('value', directions[i]);
		mxUtils.write(gradientOption, mxResources.get(directions[i]));
		gradientSelect.appendChild(gradientOption);
	}

	gradientPanel.appendChild(gradientSelect);

	var listener = mxUtils.bind(this, function () {
		ss = this.format.getSelectionState();
		var value = mxUtils.getValue(ss.style, mxConstants.STYLE_GRADIENT_DIRECTION, mxConstants.DIRECTION_SOUTH);

		// Handles empty string which is not allowed as a value
		if (value == '') {
			value = mxConstants.DIRECTION_SOUTH;
		}

		gradientSelect.value = value;
		container.style.display = (ss.fill) ? '' : 'none';

		var fillColor = mxUtils.getValue(ss.style, mxConstants.STYLE_FILLCOLOR, null);

		if (!ss.fill || ss.containsImage || fillColor == null || fillColor == mxConstants.NONE) {
			gradientPanel.style.display = 'none';
		}
		else {
			gradientPanel.style.display = '';
		}
	});

	graph.getModel().addListener(mxEvent.CHANGE, listener);
	this.listeners.push({
		destroy: function () {
			graph.getModel().removeListener(listener);
		}
	});
	listener();

	mxEvent.addListener(gradientSelect, 'change', function (evt) {
		graph.setCellStyles(mxConstants.STYLE_GRADIENT_DIRECTION, gradientSelect.value, graph.getSelectionCells());
		mxEvent.consume(evt);
	});

	container.appendChild(fillPanel);
	container.appendChild(gradientPanel);

	if (ss.style.shape == 'swimlane') {
		container.appendChild(this.createCellColorOption(mxResources.get('laneColor'), 'swimlaneFillColor', '#ffffff'));
	}

	return container;
};

StyleFormatPanel.prototype.addAssetGroupContainer = function (container) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;
	container.style.paddingTop = '6px';
	container.style.paddingBottom = '6px';

	var fillPanel = this.createCellColorOption(i18n('Container background'), "assetGroupContainerBackground", '#FFFFFF');
	fillPanel.style.fontWeight = 'bold';

	const key = 'assetGroupContainerBackgroundOpacity'
	const opacityPanel = this.createRelativeOption(i18n('Container background opacity'), key, null)
	opacityPanel.style.borderBottom = 'none';

	container.appendChild(fillPanel);
	container.appendChild(opacityPanel);

	return container;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
StyleFormatPanel.prototype.addStroke = function (container) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;
	var ss = this.format.getSelectionState();

	container.style.paddingTop = '4px';
	container.style.paddingBottom = '4px';
	container.style.whiteSpace = 'normal';

	var colorPanel = document.createElement('div');
	colorPanel.style.fontWeight = 'bold';

	// Adds gradient direction option
	var styleSelect = document.createElement('select');
	styleSelect.style.position = 'absolute';
	styleSelect.style.marginTop = '-2px';
	styleSelect.style.right = '72px';
	styleSelect.style.width = '80px';

	var styles = ['sharp', 'rounded', 'curved'];

	for (var i = 0; i < styles.length; i++) {
		var styleOption = document.createElement('option');
		styleOption.setAttribute('value', styles[i]);
		mxUtils.write(styleOption, mxResources.get(styles[i]));
		styleSelect.appendChild(styleOption);
	}

	mxEvent.addListener(styleSelect, 'change', function (evt) {
		graph.getModel().beginUpdate();
		try {
			var keys = [mxConstants.STYLE_ROUNDED, mxConstants.STYLE_CURVED];
			// Default for rounded is 1
			var values = ['0', null];

			if (styleSelect.value == 'rounded') {
				values = ['1', null];
			}
			else if (styleSelect.value == 'curved') {
				values = [null, '1'];
			}

			for (var i = 0; i < keys.length; i++) {
				graph.setCellStyles(keys[i], values[i], graph.getSelectionCells());
			}

			ui.fireEvent(new mxEventObject('styleChanged', 'keys', keys,
				'values', values, 'cells', graph.getSelectionCells()));
		}
		finally {
			graph.getModel().endUpdate();
		}

		mxEvent.consume(evt);
	});

	// Stops events from bubbling to color option event handler
	mxEvent.addListener(styleSelect, 'click', function (evt) {
		mxEvent.consume(evt);
	});

	var strokeKey = (ss.style.shape == 'image') ? mxConstants.STYLE_IMAGE_BORDER : mxConstants.STYLE_STROKECOLOR;

	var lineColor = this.createCellColorOption(mxResources.get('line'), strokeKey, '#000000');
	lineColor.appendChild(styleSelect);
	colorPanel.appendChild(lineColor);

	// Used if only edges selected
	var stylePanel = colorPanel.cloneNode(false);
	stylePanel.style.fontWeight = 'normal';
	stylePanel.style.whiteSpace = 'nowrap';
	stylePanel.style.position = 'relative';
	stylePanel.style.paddingLeft = '16px'
	stylePanel.style.marginBottom = '2px';
	stylePanel.style.marginTop = '2px';
	stylePanel.className = 'geToolbarContainer';

	var addItem = mxUtils.bind(this, function (menu, width, cssName, keys, values) {
		var item = this.editorUi.menus.styleChange(menu, '', keys, values, 'geIcon', null);

		var pat = document.createElement('div');
		pat.style.width = width + 'px';
		pat.style.height = '1px';
		pat.style.borderBottom = '1px ' + cssName + ' black';
		pat.style.paddingTop = '6px';

		item.firstChild.firstChild.style.padding = '0px 4px 0px 4px';
		item.firstChild.firstChild.style.width = width + 'px';
		item.firstChild.firstChild.appendChild(pat);

		return item;
	});


	var pattern = this.addMenuFunctionInContainer(stylePanel, 'geSprite-orthogonal', mxResources.get('pattern'), false, mxUtils.bind(this, function (menu) {
		addItem(menu, 75, 'solid', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], [null, null]).setAttribute('title', mxResources.get('solid'));
		addItem(menu, 75, 'dashed', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', null]).setAttribute('title', mxResources.get('dashed'));
		addItem(menu, 75, 'dotted', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', '1 1']).setAttribute('title', mxResources.get('dotted') + ' (1)');
		if(!this.anyHtmlContainerCells) {
			addItem(menu, 75, 'dotted', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', '1 2']).setAttribute('title', mxResources.get('dotted') + ' (2)');
			addItem(menu, 75, 'dotted', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', '1 4']).setAttribute('title', mxResources.get('dotted') + ' (3)');
		}
	}));

	// Used for mixed selection (vertices and edges)
	var altStylePanel = stylePanel.cloneNode(false);

	var edgeShape = this.addMenuFunctionInContainer(altStylePanel, 'geSprite-connection', mxResources.get('connection'), false, mxUtils.bind(this, function (menu) {
		this.editorUi.menus.styleChange(menu, '', [mxConstants.STYLE_SHAPE, mxConstants.STYLE_STARTSIZE, mxConstants.STYLE_ENDSIZE, 'width'], [null, null, null, null], 'geIcon geSprite geSprite-connection', null, true).setAttribute('title', mxResources.get('line'));
		this.editorUi.menus.styleChange(menu, '', [mxConstants.STYLE_SHAPE, mxConstants.STYLE_STARTSIZE, mxConstants.STYLE_ENDSIZE, 'width'], ['link', null, null, null], 'geIcon geSprite geSprite-linkedge', null, true).setAttribute('title', mxResources.get('link'));
		this.editorUi.menus.styleChange(menu, '', [mxConstants.STYLE_SHAPE, mxConstants.STYLE_STARTSIZE, mxConstants.STYLE_ENDSIZE, 'width'], ['flexArrow', null, null, null], 'geIcon geSprite geSprite-arrow', null, true).setAttribute('title', mxResources.get('arrow'));
		this.editorUi.menus.styleChange(menu, '', [mxConstants.STYLE_SHAPE, mxConstants.STYLE_STARTSIZE, mxConstants.STYLE_ENDSIZE, 'width'], ['arrow', null, null, null], 'geIcon geSprite geSprite-simplearrow', null, true).setAttribute('title', mxResources.get('simpleArrow'));
	}));


	var altPattern = this.addMenuFunctionInContainer(altStylePanel, 'geSprite-orthogonal', mxResources.get('pattern'), false, mxUtils.bind(this, function (menu) {
		addItem(menu, 33, 'solid', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], [null, null]).setAttribute('title', mxResources.get('solid'));
		addItem(menu, 33, 'dashed', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', null]).setAttribute('title', mxResources.get('dashed'));
		addItem(menu, 33, 'dotted', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', '1 1']).setAttribute('title', mxResources.get('dotted') + ' (1)');
		if(!this.anyHtmlContainerCells) {
			addItem(menu, 33, 'dotted', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', '1 2']).setAttribute('title', mxResources.get('dotted') + ' (2)');
			addItem(menu, 33, 'dotted', [mxConstants.STYLE_DASHED, mxConstants.STYLE_DASH_PATTERN], ['1', '1 4']).setAttribute('title', mxResources.get('dotted') + ' (3)');
		}
	}));


	var stylePanel2 = stylePanel.cloneNode(false);

	// Stroke width
	var input = document.createElement('input');
	input.style.textAlign = 'right';
	input.style.marginTop = '2px';
	input.style.width = '41px';
	input.setAttribute('title', mxResources.get('linewidth'));

	stylePanel.appendChild(input);

	var altInput = input.cloneNode(true);
	altStylePanel.appendChild(altInput);

	function update(evt) {
		// Maximum stroke width is 999
		var value = parseInt(input.value);
		value = Math.min(999, Math.max(1, (isNaN(value)) ? 1 : value));

		if (value != mxUtils.getValue(ss.style, mxConstants.STYLE_STROKEWIDTH, 1)) {
			graph.setCellStyles(mxConstants.STYLE_STROKEWIDTH, value, graph.getSelectionCells());
			ui.fireEvent(new mxEventObject('styleChanged', 'keys', [mxConstants.STYLE_STROKEWIDTH],
				'values', [value], 'cells', graph.getSelectionCells()));
		}

		input.value = value + ' pt';
		mxEvent.consume(evt);
	};

	function altUpdate(evt) {
		// Maximum stroke width is 999
		var value = parseInt(altInput.value);
		value = Math.min(999, Math.max(1, (isNaN(value)) ? 1 : value));

		if (value != mxUtils.getValue(ss.style, mxConstants.STYLE_STROKEWIDTH, 1)) {
			graph.setCellStyles(mxConstants.STYLE_STROKEWIDTH, value, graph.getSelectionCells());
			ui.fireEvent(new mxEventObject('styleChanged', 'keys', [mxConstants.STYLE_STROKEWIDTH],
				'values', [value], 'cells', graph.getSelectionCells()));
		}

		altInput.value = value + ' pt';
		mxEvent.consume(evt);
	};

	var stepper = this.createStepper(input, update, 1, 9);
	stepper.style.display = input.style.display;
	stepper.style.marginTop = '2px';
	stylePanel.appendChild(stepper);

	var altStepper = this.createStepper(altInput, altUpdate, 1, 9);
	altStepper.style.display = altInput.style.display;
	altStepper.style.marginTop = '2px';
	altStylePanel.appendChild(altStepper);

	if (!mxClient.IS_QUIRKS) {
		input.style.position = 'absolute';
		input.style.right = '32px';
		input.style.height = '15px';
		stepper.style.right = '20px';

		altInput.style.position = 'absolute';
		altInput.style.right = '32px';
		altInput.style.height = '15px';
		altStepper.style.right = '20px';
	}
	else {
		input.style.height = '17px';
		altInput.style.height = '17px';
	}

	mxEvent.addListener(input, 'blur', update);
	mxEvent.addListener(input, 'change', update);

	mxEvent.addListener(altInput, 'blur', altUpdate);
	mxEvent.addListener(altInput, 'change', altUpdate);

	if (mxClient.IS_QUIRKS) {
		mxUtils.br(stylePanel2);
		mxUtils.br(stylePanel2);
	}

	var edgeStyle = this.addMenuFunctionInContainer(stylePanel2, 'geSprite-orthogonal', mxResources.get('waypoints'), false, mxUtils.bind(this, function (menu) {
		if (ss.style.shape != 'arrow') {
			this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], [null, null, null], 'geIcon geSprite geSprite-straight', null, true).setAttribute('title', mxResources.get('straight'));
			this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], ['orthogonalEdgeStyle', null, null], 'geIcon geSprite geSprite-orthogonal', null, true).setAttribute('title', mxResources.get('orthogonal'));
			this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_ELBOW, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], ['elbowEdgeStyle', null, null, null], 'geIcon geSprite geSprite-horizontalelbow', null, true).setAttribute('title', mxResources.get('simple'));
			this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_ELBOW, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], ['elbowEdgeStyle', 'vertical', null, null], 'geIcon geSprite geSprite-verticalelbow', null, true).setAttribute('title', mxResources.get('simple'));
			this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_ELBOW, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], ['isometricEdgeStyle', null, null, null], 'geIcon geSprite geSprite-horizontalisometric', null, true).setAttribute('title', mxResources.get('isometric'));
			this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_ELBOW, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], ['isometricEdgeStyle', 'vertical', null, null], 'geIcon geSprite geSprite-verticalisometric', null, true).setAttribute('title', mxResources.get('isometric'));

			if (ss.style.shape == 'connector') {
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], ['orthogonalEdgeStyle', '1', null], 'geIcon geSprite geSprite-curved', null, true).setAttribute('title', mxResources.get('curved'));
			}

			this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_EDGE, mxConstants.STYLE_CURVED, mxConstants.STYLE_NOEDGESTYLE], ['entityRelationEdgeStyle', null, null], 'geIcon geSprite geSprite-entity', null, true).setAttribute('title', mxResources.get('entityRelation'));
		}
	}));

	var lineStart = this.addMenuFunctionInContainer(stylePanel2, 'geSprite-startclassic', mxResources.get('linestart'), false, mxUtils.bind(this, function (menu) {
		if (ss.style.shape == 'connector' || ss.style.shape == 'flexArrow') {
			var item = this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.NONE, 0], 'geIcon', null, false);
			item.setAttribute('title', mxResources.get('none'));
			item.firstChild.firstChild.innerHTML = '<font style="font-size:10px;">' + mxUtils.htmlEntities(mxResources.get('none')) + '</font>';

			if (ss.style.shape == 'connector') {
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_CLASSIC, 1], 'geIcon geSprite geSprite-startclassic', null, false).setAttribute('title', mxResources.get('classic'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_CLASSIC_THIN, 1], 'geIcon geSprite geSprite-startclassicthin', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_OPEN, 0], 'geIcon geSprite geSprite-startopen', null, false).setAttribute('title', mxResources.get('openArrow'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_OPEN_THIN, 0], 'geIcon geSprite geSprite-startopenthin', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['openAsync', 0], 'geIcon geSprite geSprite-startopenasync', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_BLOCK, 1], 'geIcon geSprite geSprite-startblock', null, false).setAttribute('title', mxResources.get('block'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_BLOCK_THIN, 1], 'geIcon geSprite geSprite-startblockthin', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['async', 1], 'geIcon geSprite geSprite-startasync', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_OVAL, 1], 'geIcon geSprite geSprite-startoval', null, false).setAttribute('title', mxResources.get('oval'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_DIAMOND, 1], 'geIcon geSprite geSprite-startdiamond', null, false).setAttribute('title', mxResources.get('diamond'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_DIAMOND_THIN, 1], 'geIcon geSprite geSprite-startthindiamond', null, false).setAttribute('title', mxResources.get('diamondThin'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_CLASSIC, 0], 'geIcon geSprite geSprite-startclassictrans', null, false).setAttribute('title', mxResources.get('classic'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_CLASSIC_THIN, 0], 'geIcon geSprite geSprite-startclassicthintrans', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_BLOCK, 0], 'geIcon geSprite geSprite-startblocktrans', null, false).setAttribute('title', mxResources.get('block'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_BLOCK_THIN, 0], 'geIcon geSprite geSprite-startblockthintrans', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['async', 0], 'geIcon geSprite geSprite-startasynctrans', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_OVAL, 0], 'geIcon geSprite geSprite-startovaltrans', null, false).setAttribute('title', mxResources.get('oval'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_DIAMOND, 0], 'geIcon geSprite geSprite-startdiamondtrans', null, false).setAttribute('title', mxResources.get('diamond'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], [mxConstants.ARROW_DIAMOND_THIN, 0], 'geIcon geSprite geSprite-startthindiamondtrans', null, false).setAttribute('title', mxResources.get('diamondThin'));

				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['dash', 0], 'geIcon geSprite geSprite-startdash', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['cross', 0], 'geIcon geSprite geSprite-startcross', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['circlePlus', 0], 'geIcon geSprite geSprite-startcircleplus', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['circle', 1], 'geIcon geSprite geSprite-startcircle', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['ERone', 0], 'geIcon geSprite geSprite-starterone', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['ERmandOne', 0], 'geIcon geSprite geSprite-starteronetoone', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['ERmany', 0], 'geIcon geSprite geSprite-startermany', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['ERoneToMany', 0], 'geIcon geSprite geSprite-starteronetomany', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['ERzeroToOne', 1], 'geIcon geSprite geSprite-starteroneopt', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW, 'startFill'], ['ERzeroToMany', 1], 'geIcon geSprite geSprite-startermanyopt', null, false);
			}
			else {
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_STARTARROW], [mxConstants.ARROW_BLOCK], 'geIcon geSprite geSprite-startblocktrans', null, false).setAttribute('title', mxResources.get('block'));
			}
		}
	}));

	var lineEnd = this.addMenuFunctionInContainer(stylePanel2, 'geSprite-endclassic', mxResources.get('lineend'), false, mxUtils.bind(this, function (menu) {
		if (ss.style.shape == 'connector' || ss.style.shape == 'flexArrow') {
			var item = this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.NONE, 0], 'geIcon', null, false);
			item.setAttribute('title', mxResources.get('none'));
			item.firstChild.firstChild.innerHTML = '<font style="font-size:10px;">' + mxUtils.htmlEntities(mxResources.get('none')) + '</font>';

			if (ss.style.shape == 'connector') {
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_CLASSIC, 1], 'geIcon geSprite geSprite-endclassic', null, false).setAttribute('title', mxResources.get('classic'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_CLASSIC_THIN, 1], 'geIcon geSprite geSprite-endclassicthin', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_OPEN, 0], 'geIcon geSprite geSprite-endopen', null, false).setAttribute('title', mxResources.get('openArrow'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_OPEN_THIN, 0], 'geIcon geSprite geSprite-endopenthin', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['openAsync', 0], 'geIcon geSprite geSprite-endopenasync', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_BLOCK, 1], 'geIcon geSprite geSprite-endblock', null, false).setAttribute('title', mxResources.get('block'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_BLOCK_THIN, 1], 'geIcon geSprite geSprite-endblockthin', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['async', 1], 'geIcon geSprite geSprite-endasync', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_OVAL, 1], 'geIcon geSprite geSprite-endoval', null, false).setAttribute('title', mxResources.get('oval'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_DIAMOND, 1], 'geIcon geSprite geSprite-enddiamond', null, false).setAttribute('title', mxResources.get('diamond'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_DIAMOND_THIN, 1], 'geIcon geSprite geSprite-endthindiamond', null, false).setAttribute('title', mxResources.get('diamondThin'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_CLASSIC, 0], 'geIcon geSprite geSprite-endclassictrans', null, false).setAttribute('title', mxResources.get('classic'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_CLASSIC_THIN, 0], 'geIcon geSprite geSprite-endclassicthintrans', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_BLOCK, 0], 'geIcon geSprite geSprite-endblocktrans', null, false).setAttribute('title', mxResources.get('block'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_BLOCK_THIN, 0], 'geIcon geSprite geSprite-endblockthintrans', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['async', 0], 'geIcon geSprite geSprite-endasynctrans', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_OVAL, 0], 'geIcon geSprite geSprite-endovaltrans', null, false).setAttribute('title', mxResources.get('oval'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_DIAMOND, 0], 'geIcon geSprite geSprite-enddiamondtrans', null, false).setAttribute('title', mxResources.get('diamond'));
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], [mxConstants.ARROW_DIAMOND_THIN, 0], 'geIcon geSprite geSprite-endthindiamondtrans', null, false).setAttribute('title', mxResources.get('diamondThin'));

				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['dash', 0], 'geIcon geSprite geSprite-enddash', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['cross', 0], 'geIcon geSprite geSprite-endcross', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['circlePlus', 0], 'geIcon geSprite geSprite-endcircleplus', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['circle', 1], 'geIcon geSprite geSprite-endcircle', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['ERone', 0], 'geIcon geSprite geSprite-enderone', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['ERmandOne', 0], 'geIcon geSprite geSprite-enderonetoone', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['ERmany', 0], 'geIcon geSprite geSprite-endermany', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['ERoneToMany', 0], 'geIcon geSprite geSprite-enderonetomany', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['ERzeroToOne', 1], 'geIcon geSprite geSprite-enderoneopt', null, false);
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW, 'endFill'], ['ERzeroToMany', 1], 'geIcon geSprite geSprite-endermanyopt', null, false);
			}
			else {
				this.editorUi.menus.edgeStyleChange(menu, '', [mxConstants.STYLE_ENDARROW], [mxConstants.ARROW_BLOCK], 'geIcon geSprite geSprite-endblocktrans', null, false).setAttribute('title', mxResources.get('block'));
			}
		}
	}));

	this.addArrow(edgeShape, 8);
	this.addArrow(edgeStyle);
	this.addArrow(lineStart);
	this.addArrow(lineEnd);

	var symbol = this.addArrow(pattern, 9);
	symbol.className = 'geIcon';
	symbol.style.width = '84px';

	var altSymbol = this.addArrow(altPattern, 9);
	altSymbol.className = 'geIcon';
	altSymbol.style.width = '22px';

	var solid = document.createElement('div');
	solid.style.width = '85px';
	solid.style.height = '1px';
	solid.style.borderBottom = '1px solid black';
	solid.style.marginBottom = '9px';
	symbol.appendChild(solid);

	var altSolid = document.createElement('div');
	altSolid.style.width = '23px';
	altSolid.style.height = '1px';
	altSolid.style.borderBottom = '1px solid black';
	altSolid.style.marginBottom = '9px';
	altSymbol.appendChild(altSolid);

	pattern.style.height = '15px';
	altPattern.style.height = '15px';

	edgeShape.style.height = '15px';
	edgeStyle.style.height = '17px';
	lineStart.style.marginLeft = '3px';
	lineStart.style.height = '17px';
	lineEnd.style.marginLeft = '3px';
	lineEnd.style.height = '17px';

	container.appendChild(colorPanel);
	container.appendChild(altStylePanel);
	container.appendChild(stylePanel);

	var arrowPanel = stylePanel.cloneNode(false);
	arrowPanel.style.paddingBottom = '6px';
	arrowPanel.style.paddingTop = '4px';
	arrowPanel.style.fontWeight = 'normal';

	var span = document.createElement('div');
	span.style.position = 'absolute';
	span.style.marginLeft = '3px';
	span.style.marginBottom = '12px';
	span.style.marginTop = '2px';
	span.style.fontWeight = 'normal';
	span.style.width = '76px';

	mxUtils.write(span, mxResources.get('lineend'));
	arrowPanel.appendChild(span);

	var endSpacingUpdate, endSizeUpdate;
	var endSpacing = this.addUnitInput(arrowPanel, 'pt', 74, 33, function () {
		endSpacingUpdate.apply(this, arguments);
	});
	var endSize = this.addUnitInput(arrowPanel, 'pt', 20, 33, function () {
		endSizeUpdate.apply(this, arguments);
	});

	mxUtils.br(arrowPanel);

	var spacer = document.createElement('div');
	spacer.style.height = '8px';
	arrowPanel.appendChild(spacer);

	span = span.cloneNode(false);
	mxUtils.write(span, mxResources.get('linestart'));
	arrowPanel.appendChild(span);

	var startSpacingUpdate, startSizeUpdate;
	var startSpacing = this.addUnitInput(arrowPanel, 'pt', 74, 33, function () {
		startSpacingUpdate.apply(this, arguments);
	});
	var startSize = this.addUnitInput(arrowPanel, 'pt', 20, 33, function () {
		startSizeUpdate.apply(this, arguments);
	});

	mxUtils.br(arrowPanel);
	this.addLabel(arrowPanel, mxResources.get('spacing'), 74, 50);
	this.addLabel(arrowPanel, mxResources.get('size'), 20, 50);
	mxUtils.br(arrowPanel);

	if(!this.anyHtmlContainerCells) {
		var perimeterPanel = colorPanel.cloneNode(false);
		perimeterPanel.style.fontWeight = 'normal';
		perimeterPanel.style.position = 'relative';
		perimeterPanel.style.paddingLeft = '16px'
		perimeterPanel.style.marginBottom = '2px';
		perimeterPanel.style.marginTop = '6px';
		perimeterPanel.style.borderWidth = '0px';
		perimeterPanel.style.paddingBottom = '18px';


		var span = document.createElement('div');
		span.style.position = 'absolute';
		span.style.marginLeft = '3px';
		span.style.marginBottom = '12px';
		span.style.marginTop = '1px';
		span.style.fontWeight = 'normal';
		span.style.width = '120px';
		mxUtils.write(span, mxResources.get('perimeter'));
		perimeterPanel.appendChild(span);

		var perimeterUpdate;
		var perimeterSpacing = this.addUnitInput(perimeterPanel, 'pt', 20, 41, function () {
			perimeterUpdate.apply(this, arguments);
		});
	}

	if (ss.edges.length == graph.getSelectionCount()) {
		container.appendChild(stylePanel2);

		if (mxClient.IS_QUIRKS) {
			mxUtils.br(container);
			mxUtils.br(container);
		}

		container.appendChild(arrowPanel);
	}
	else if (ss.vertices.length == graph.getSelectionCount()) {
		if (mxClient.IS_QUIRKS) {
			mxUtils.br(container);
		}

		if(!this.anyHtmlContainerCells) {
			container.appendChild(perimeterPanel);
		}
	}

	var listener = mxUtils.bind(this, function (sender, evt, force) {
		ss = this.format.getSelectionState();
		var color = mxUtils.getValue(ss.style, strokeKey, null);

		if (force || document.activeElement != input) {
			var tmp = parseInt(mxUtils.getValue(ss.style, mxConstants.STYLE_STROKEWIDTH, 1));
			input.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != altInput) {
			var tmp = parseInt(mxUtils.getValue(ss.style, mxConstants.STYLE_STROKEWIDTH, 1));
			altInput.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		styleSelect.style.visibility = (ss.style.shape == 'connector') ? '' : 'hidden';

		if (mxUtils.getValue(ss.style, mxConstants.STYLE_CURVED, null) == '1') {
			styleSelect.value = 'curved';
		}
		else if (mxUtils.getValue(ss.style, mxConstants.STYLE_ROUNDED, null) == '1') {
			styleSelect.value = 'rounded';
		}

		if (mxUtils.getValue(ss.style, mxConstants.STYLE_DASHED, null) == '1') {
			if (mxUtils.getValue(ss.style, mxConstants.STYLE_DASH_PATTERN, null) == null) {
				solid.style.borderBottom = '1px dashed black';
			} else {
				solid.style.borderBottom = '1px dotted black';
			}
		} else {
			solid.style.borderBottom = '1px solid black';
		}

		altSolid.style.borderBottom = solid.style.borderBottom;


		// Updates toolbar icon for edge style
		var edgeStyleDiv = edgeStyle.getElementsByTagName('div')[0];
		var es = mxUtils.getValue(ss.style, mxConstants.STYLE_EDGE, null);

		if (mxUtils.getValue(ss.style, mxConstants.STYLE_NOEDGESTYLE, null) == '1') {
			es = null;
		}

		if (es == 'orthogonalEdgeStyle' && mxUtils.getValue(ss.style, mxConstants.STYLE_CURVED, null) == '1') {
			edgeStyleDiv.className = 'geSprite geSprite-curved';
		}
		else if (es == 'straight' || es == 'none' || es == null) {
			edgeStyleDiv.className = 'geSprite geSprite-straight';
		}
		else if (es == 'entityRelationEdgeStyle') {
			edgeStyleDiv.className = 'geSprite geSprite-entity';
		}
		else if (es == 'elbowEdgeStyle') {
			edgeStyleDiv.className = 'geSprite ' + ((mxUtils.getValue(ss.style,
				mxConstants.STYLE_ELBOW, null) == 'vertical') ?
				'geSprite-verticalelbow' : 'geSprite-horizontalelbow');
		}
		else if (es == 'isometricEdgeStyle') {
			edgeStyleDiv.className = 'geSprite ' + ((mxUtils.getValue(ss.style,
				mxConstants.STYLE_ELBOW, null) == 'vertical') ?
				'geSprite-verticalisometric' : 'geSprite-horizontalisometric');
		}
		else {
			edgeStyleDiv.className = 'geSprite geSprite-orthogonal';
		}

		// Updates icon for edge shape
		var edgeShapeDiv = edgeShape.getElementsByTagName('div')[0];

		if (ss.style.shape == 'link') {
			edgeShapeDiv.className = 'geSprite geSprite-linkedge';
		}
		else if (ss.style.shape == 'flexArrow') {
			edgeShapeDiv.className = 'geSprite geSprite-arrow';
		}
		else if (ss.style.shape == 'arrow') {
			edgeShapeDiv.className = 'geSprite geSprite-simplearrow';
		}
		else {
			edgeShapeDiv.className = 'geSprite geSprite-connection';
		}

		if (ss.edges.length == graph.getSelectionCount()) {
			altStylePanel.style.display = '';
			stylePanel.style.display = 'none';
		}
		else {
			altStylePanel.style.display = 'none';
			stylePanel.style.display = '';
		}

		function updateArrow(marker, fill, elt, prefix) {
			var markerDiv = elt.getElementsByTagName('div')[0];

			markerDiv.className = ui.getCssClassForMarker(prefix, ss.style.shape, marker, fill);

			if (markerDiv.className == 'geSprite geSprite-noarrow') {
				markerDiv.innerHTML = mxUtils.htmlEntities(mxResources.get('none'));
				markerDiv.style.backgroundImage = 'none';
				markerDiv.style.verticalAlign = 'top';
				markerDiv.style.marginTop = '5px';
				markerDiv.style.fontSize = '10px';
				markerDiv.nextSibling.style.marginTop = '0px';
			}

			return markerDiv;
		};

		var sourceDiv = updateArrow(mxUtils.getValue(ss.style, mxConstants.STYLE_STARTARROW, null),
			mxUtils.getValue(ss.style, 'startFill', '1'), lineStart, 'start');
		var targetDiv = updateArrow(mxUtils.getValue(ss.style, mxConstants.STYLE_ENDARROW, null),
			mxUtils.getValue(ss.style, 'endFill', '1'), lineEnd, 'end');

		// Special cases for markers
		if (ss.style.shape == 'arrow') {
			sourceDiv.className = 'geSprite geSprite-noarrow';
			targetDiv.className = 'geSprite geSprite-endblocktrans';
		}
		else if (ss.style.shape == 'link') {
			sourceDiv.className = 'geSprite geSprite-noarrow';
			targetDiv.className = 'geSprite geSprite-noarrow';
		}

		mxUtils.setOpacity(edgeStyle, (ss.style.shape == 'arrow') ? 30 : 100);

		if (ss.style.shape != 'connector' && ss.style.shape != 'flexArrow') {
			mxUtils.setOpacity(lineStart, 30);
			mxUtils.setOpacity(lineEnd, 30);
		}
		else {
			mxUtils.setOpacity(lineStart, 100);
			mxUtils.setOpacity(lineEnd, 100);
		}

		if (force || document.activeElement != startSize) {
			var tmp = parseInt(mxUtils.getValue(ss.style, mxConstants.STYLE_STARTSIZE, mxConstants.DEFAULT_MARKERSIZE));
			startSize.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != startSpacing) {
			var tmp = parseInt(mxUtils.getValue(ss.style, mxConstants.STYLE_SOURCE_PERIMETER_SPACING, 0));
			startSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != endSize) {
			var tmp = parseInt(mxUtils.getValue(ss.style, mxConstants.STYLE_ENDSIZE, mxConstants.DEFAULT_MARKERSIZE));
			endSize.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if (force || document.activeElement != startSpacing) {
			var tmp = parseInt(mxUtils.getValue(ss.style, mxConstants.STYLE_TARGET_PERIMETER_SPACING, 0));
			endSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
		}

		if(!this.anyHtmlContainerCells) {
			if (force || document.activeElement != perimeterSpacing) {
				var tmp = parseInt(mxUtils.getValue(ss.style, mxConstants.STYLE_PERIMETER_SPACING, 0));
				perimeterSpacing.value = (isNaN(tmp)) ? '' : tmp + ' pt';
			}
		}
	});

	startSizeUpdate = this.installInputHandler(startSize, mxConstants.STYLE_STARTSIZE, mxConstants.DEFAULT_MARKERSIZE, 0, 999, ' pt');
	startSpacingUpdate = this.installInputHandler(startSpacing, mxConstants.STYLE_SOURCE_PERIMETER_SPACING, 0, -999, 999, ' pt');
	endSizeUpdate = this.installInputHandler(endSize, mxConstants.STYLE_ENDSIZE, mxConstants.DEFAULT_MARKERSIZE, 0, 999, ' pt');
	endSpacingUpdate = this.installInputHandler(endSpacing, mxConstants.STYLE_TARGET_PERIMETER_SPACING, 0, -999, 999, ' pt');
	if(!this.anyHtmlContainerCells) {
		perimeterUpdate = this.installInputHandler(perimeterSpacing, mxConstants.STYLE_PERIMETER_SPACING, 0, 0, 999, ' pt');
	}

	this.addKeyHandler(input, listener);
	this.addKeyHandler(startSize, listener);
	this.addKeyHandler(startSpacing, listener);
	this.addKeyHandler(endSize, listener);
	this.addKeyHandler(endSpacing, listener);
	if(!this.anyHtmlContainerCells) {
		this.addKeyHandler(perimeterSpacing, listener);
	}

	graph.getModel().addListener(mxEvent.CHANGE, listener);
	this.listeners.push({
		destroy: function () {
			graph.getModel().removeListener(listener);
		}
	});
	listener();

	return container;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
StyleFormatPanel.prototype.addEffects = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;
	var ss = this.format.getSelectionState();

	div.style.paddingTop = '0px';
	div.style.paddingBottom = '2px';

	var table = document.createElement('table');

	if (mxClient.IS_QUIRKS) {
		table.style.fontSize = '1em';
	}

	table.style.width = '100%';
	table.style.fontWeight = 'bold';
	table.style.paddingRight = '20px';
	var tbody = document.createElement('tbody');
	var row = document.createElement('tr');
	row.style.padding = '0px';
	var left = document.createElement('td');
	left.style.padding = '0px';
	left.style.width = '50%';
	left.setAttribute('valign', 'top');

	var right = left.cloneNode(true);
	right.style.paddingLeft = '8px';
	row.appendChild(left);
	row.appendChild(right);
	tbody.appendChild(row);
	table.appendChild(tbody);
	div.appendChild(table);

	var current = left;
	var count = 0;

	var addOption = mxUtils.bind(this, function (label, key, defaultValue) {
		var opt = this.createCellOption(label, key, defaultValue);
		opt.style.width = '100%';
		current.appendChild(opt);
		current = (current == left) ? right : left;
		count++;
	});

	var listener = mxUtils.bind(this, function (sender, evt, force) {
		ss = this.format.getSelectionState();

		left.innerHTML = '';
		right.innerHTML = '';
		current = left;

		if (ss.rounded) {
			addOption(mxResources.get('rounded'), mxConstants.STYLE_ROUNDED, 0);
		}

		if (ss.style.shape == 'swimlane') {
			addOption(mxResources.get('divider'), 'swimlaneLine', 1);
		}

		//if (!ss.containsImage)
		//{
		addOption(mxResources.get('shadow'), mxConstants.STYLE_SHADOW, 0);
		//}

		if (ss.glass) {
			addOption(mxResources.get('glass'), mxConstants.STYLE_GLASS, 0);
		}

		if (ss.comic) {
			addOption(mxResources.get('comic'), 'comic', 0);
		}

		if (count == 0) {
			div.style.display = 'none';
		}
	});

	graph.getModel().addListener(mxEvent.CHANGE, listener);
	this.listeners.push({
		destroy: function () {
			graph.getModel().removeListener(listener);
		}
	});
	listener();

	return div;
}

/**
 * Adds the label menu items to the given menu and parent.
 */
StyleFormatPanel.prototype.addStyleOps = function (div) {
	div.style.paddingTop = '10px';
	div.style.paddingBottom = '10px';

	var btn = mxUtils.button(mxResources.get('setAsDefaultStyle'), mxUtils.bind(this, function (evt) {
		this.editorUi.actions.get('setAsDefaultStyle').funct();
	}));

	btn.setAttribute('title', mxResources.get('setAsDefaultStyle') + ' (' + this.editorUi.actions.get('setAsDefaultStyle').shortcut + ')');
	btn.style.width = '202px';
	div.appendChild(btn);

	return div;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
window.DiagramFormatPanel = function (format, editorUi, container) {
	BaseFormatPanel.call(this, format, editorUi, container);
	this.init();
};

mxUtils.extend(DiagramFormatPanel, BaseFormatPanel);

/**
 * Specifies if the background image option should be shown. Default is true.
 */
DiagramFormatPanel.prototype.showBackgroundImageOption = true;

/**
 * Adds the label menu items to the given menu and parent.
 */
DiagramFormatPanel.prototype.init = function () {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;
	this.statusNotification = new CustomNotification({
		appendToElement: '.geEditor ',
		status: 'success',
		type: 'icon',
		hideOnClick: true
	});

	this.container.appendChild(this.addView(this.createPanel()));

	this.container.appendChild(this.addDesign(this.createPanel()));

	if (this.editorUi.config.mode == 'service') {
		this.container.appendChild(this.addServiceDesignerProperties());
	}

	if(this.editorUi.config.features.presentationMode){
		this.container.appendChild(this.addPresentationMode());
	}

	if(this.editorUi.config.features.previewPaddings){
		this.addPreviewPaddings()
	}
};

/**
 * Adds the label menu items to the given menu and parent.
 */
DiagramFormatPanel.prototype.addView = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;

	div.appendChild(this.createTitle(i18n('Layout')));
	div.style.overflow = 'hidden';
	// Grid
	this.addGridOption(div);

	if (graph.isEnabled()) {
		if(graph.designer.config.features?.snapToGrid) {
			div.appendChild(this.createOption(i18n('Snap to grid'), function () {
				return graph.snapToGrid;
			}, function (checked) {
				graph.snapToGrid = checked;
			}));
		}

		div.appendChild(this.createOption(mxResources.get('guides'), function () {
				return graph.graphHandler.guidesEnabled;
			}, function (checked) {
				ui.actions.get('guides').funct();
			},
			{
				install: function (apply) {
					this.listener = function () {
						apply(graph.graphHandler.guidesEnabled);
					};

					ui.addListener('guidesEnabledChanged', this.listener);
				},
				destroy: function () {
					ui.removeListener(this.listener);
				}
			}));
	}

	graph.fireEvent(new mxEventObject(DesignerEvents.DiagramPropertiesRendered, 'panel', this, 'container', div), graph.designer);

	return div;
};

DiagramFormatPanel.prototype.addDesign = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;

	div.appendChild(this.createTitle(i18n('Design')));
	div.style.overflow = 'hidden';

	if (graph.isEnabled()) {

		// Background
		var bg = this.createColorOption(mxResources.get('backgroundColor'), function () {
				return graph.background;
			}, function (color) {
				ui.setBackgroundColor(color);
			}, '#ffffff',
			{
				install: function (apply) {
					this.listener = function () {
						apply(graph.background);
					};

					ui.addListener('backgroundColorChanged', this.listener);
				},
				destroy: function () {
					ui.removeListener(this.listener);
				}
			});

		div.appendChild(bg);

		if (this.showBackgroundImageOption) {
			var currentBgImage = graph.getBackgroundImage();
			//let imageName = currentBgImage ? + `<p>${currentBgImage.title}</p>` : '';
			var panelRow = $(
				'<div class="panel-row">' +
				'<div class="label">' + i18n('Background image') + '</div>' +
				//imageName +
				'<div class="form-element buttons-list">' +
				'<input type="button" value="' + i18n('Select...') + '" class="k-button k-primary _select" />' +
				'<input type="button" class="k-button _clear" value="' + i18n('Clear') + '"/>' +
				'</div>' +
				'</div>');

			div.appendChild(panelRow[0]);

			$('._select', panelRow).click($.proxy(function () {
				var modalContent = '';
				modalContent += '<div id="imageUploaderModal" class="cw_media_library_content"></div>';
				modalContent += '<div class="actions">';
				modalContent += '<button class="k-button right" id="icon_cancel">' + i18n('Cancel') + '</button>';
				modalContent += '<button class="k-button k-primary go_right" id="change_icon">' + i18n('Update') + '</button>';
				modalContent += '</div>';
				modalContent += '<div class="status"><p></p></div>';

				if (!$('#modal').length) {
					$('body').append('<div id="modal"></div>');
				}
				$('#modal').kendoWindow({
					title: i18n('Media library'),
					width: '640',
					height: '480',
					modal: true,
					close: function () {
						$('#modal').data("kendoWindow").destroy();
						$('#modal').remove();
					}
				});

				var modalWindow = $('#modal').data("kendoWindow");
				modalWindow.content(modalContent);
				modalWindow.center();
				modalWindow.open()


				var imageUploader = new ImageUploader({
					id: 'imageUploaderModal',
					onImageSelected: $.proxy(function (selectedImage) {
						ui.setBackgroundImageCustom(selectedImage.id, selectedImage.title);
					}, this)
				});

				$('#change_icon').off()
					.on('click', $.proxy(function () {
						$('#modal')
							.data("kendoWindow")
							.close();
					}, this));

				$('#icon_cancel').off().on('click', $.proxy(function () {
					var modalWindow = $('#modal').data("kendoWindow");

					if (currentBgImage != graph.getBackgroundImage()) {
						ui.setBackgroundImage(currentBgImage);
					}

					modalWindow.close();
				}, this));
			}, this));


			$('._clear', panelRow).click(function () {
				ui.setBackgroundImage(null);
			})

			var onBackgroundImageChanged = function () {
				if (ui.editor.graph.getBackgroundImage() != null) {
					$('._clear', panelRow).removeAttr("disabled");
				} else {
					$('._clear', panelRow).attr("disabled", "disabled");
				}
			}
			ui.addListener('backgroundImageChanged', onBackgroundImageChanged);
			onBackgroundImageChanged();
		}
	}

	graph.fireEvent(new mxEventObject(DesignerEvents.DiagramPropertiesRendered, 'panel', this, 'container', div), graph.designer);

	return div;
};


DiagramFormatPanel.prototype.addPresentationMode = function () {
	let div = this.createPanel();
	const {graph} = this.editorUi.editor;

	div.appendChild(this.createOption(i18n('Show Maximize/Minimize icon'), function () {
			return graph.presentationModeSettings?.showIcons;
		}, function (checked) {
			graph.presentationModeSettings.showIcons = checked;
		}));

	return div;
}

DiagramFormatPanel.prototype.addPreviewPaddings = function () {
	const {graph} = this.editorUi.editor;

	var row = this.createRow(i18n('Preview Padding'), '<input type="text" name="previewPaddings"/>');
	var input = $(':input', row);
	input.change( e => {
		graph.previewPaddings = e.target.value;
	});
	input.val(graph.previewPaddings);
}

DiagramFormatPanel.prototype.addServiceDesignerProperties = function () {
	let div = this.createPanel();
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;
	div.style.paddingTop = '6px';
	div.style.paddingBottom = '12px';

	this.createDropdownRow(mxResources.get('layout'), {
		dataSource: {
			data: [
				{text: i18n('Default'), value: "default"},
				{text: mxResources.get('horizontalFlow'), value: "horizontalFlow"},
				{text: mxResources.get('verticalFlow'), value: "verticalFlow"},
				{text: mxResources.get('horizontalTree'), value: "horizontalTree"},
				{text: mxResources.get('verticalTree'), value: "verticalTree"},
				{text: mxResources.get('radialTree'), value: "radialTree"},
				{text: mxResources.get('organic'), value: "organic"},
				{text: mxResources.get('circle'), value: "circle"}
			]
		},
		dataTextField: "text",
		dataValueField: "value",
		value: graph.layout,
		select: function (e) {
			ui.actions.get('sd-execute-layout').funct(e.dataItem.value);
		}
		/*select: e => {
			ui.actions.get('sd-execute-layout').funct(e.dataItem.value);
		}*/
	});

	const preserveLayout = this.createOption(i18n('Preserve Layout'), function () {
		return graph.layoutPreserve;
	}, function (checked) {
		graph.layoutPreserve = checked;
	});
	div.appendChild(preserveLayout);


	return div;
};



/**
 * Adds the label menu items to the given menu and parent.
 */
DiagramFormatPanel.prototype.addOptions = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;

	div.appendChild(this.createTitle(mxResources.get('options')));

	if (graph.isEnabled()) {
		// Connection arrows
		div.appendChild(this.createOption(mxResources.get('connectionArrows'), function () {
				return graph.connectionArrowsEnabled;
			}, function (checked) {
				ui.actions.get('connectionArrows').funct();
			},
			{
				install: function (apply) {
					this.listener = function () {
						apply(graph.connectionArrowsEnabled);
					};

					ui.addListener('connectionArrowsChanged', this.listener);
				},
				destroy: function () {
					ui.removeListener(this.listener);
				}
			}));

		// Connection points
		div.appendChild(this.createOption(mxResources.get('connectionPoints'), function () {
				return graph.connectionHandler.isEnabled();
			}, function (checked) {
				ui.actions.get('connectionPoints').funct();
			},
			{
				install: function (apply) {
					this.listener = function () {
						apply(graph.connectionHandler.isEnabled());
					};

					ui.addListener('connectionPointsChanged', this.listener);
				},
				destroy: function () {
					ui.removeListener(this.listener);
				}
			}));
	}

	return div;
};

/**
 *
 */
DiagramFormatPanel.prototype.addGridOption = function (container) {
	var ui = this.editorUi;
	var graph = ui.editor.graph;

	var input = document.createElement('input');
	input.style.position = 'absolute';
	input.style.textAlign = 'right';
	input.style.width = '38px';
	input.value = graph.getGridSize() + ' pt';

	var stepper = this.createStepper(input, update);
	input.style.display = (graph.isGridEnabled()) ? '' : 'none';
	stepper.style.display = input.style.display;

	mxEvent.addListener(input, 'keydown', function (e) {
		if (e.keyCode == 13) {
			graph.container.focus();
			mxEvent.consume(e);
		}
		else if (e.keyCode == 27) {
			input.value = graph.getGridSize();
			graph.container.focus();
			mxEvent.consume(e);
		}
	});

	function update(evt) {
		var value = parseInt(input.value);
		value = Math.max(1, (isNaN(value)) ? 10 : value);

		if (value != graph.getGridSize()) {
			graph.setGridSize(value)
		}

		input.value = value + ' pt';
		mxEvent.consume(evt);
	};

	mxEvent.addListener(input, 'blur', update);
	mxEvent.addListener(input, 'change', update);

	if (mxClient.IS_SVG) {
		input.style.marginTop = '-2px';
		input.style.right = '84px';
		stepper.style.marginTop = '-21px';
		stepper.style.right = '72px';

		var panel = this.createColorOption(i18n('Layout Grid'), function () {
				var color = graph.view.gridColor;

				return (graph.isGridEnabled()) ? color : null;
			}, function (color) {
				if (color == mxConstants.NONE) {
					graph.setGridEnabled(false);
					ui.fireEvent(new mxEventObject('gridEnabledChanged'));
				}
				else {
					graph.setGridEnabled(true);
					ui.setGridColor(color);
				}

				input.style.display = (graph.isGridEnabled()) ? '' : 'none';
				stepper.style.display = input.style.display;
			}, '#e0e0e0',
			{
				install: function (apply) {
					this.listener = function () {
						apply((graph.isGridEnabled()) ? graph.view.gridColor : null);
					};

					ui.addListener('gridColorChanged', this.listener);
					ui.addListener('gridEnabledChanged', this.listener);
				},
				destroy: function () {
					ui.removeListener(this.listener);
				}
			}, null, null, i18n('Layout grid tooltip'));

		panel.appendChild(input);
		panel.appendChild(stepper);
		container.appendChild(panel);
	}
	else {
		input.style.marginTop = '2px';
		input.style.right = '32px';
		stepper.style.marginTop = '2px';
		stepper.style.right = '20px';

		container.appendChild(input);
		container.appendChild(stepper);

		container.appendChild(this.createOption(mxResources.get('grid'), function () {
				return graph.isGridEnabled();
			}, function (checked) {
				graph.setGridEnabled(checked);

				if (graph.isGridEnabled()) {
					graph.view.gridColor = '#e0e0e0';
				}

				ui.fireEvent(new mxEventObject('gridEnabledChanged'));
			},
			{
				install: function (apply) {
					this.listener = function () {
						input.style.display = (graph.isGridEnabled()) ? '' : 'none';
						stepper.style.display = input.style.display;

						apply(graph.isGridEnabled());
					};

					ui.addListener('gridEnabledChanged', this.listener);
				},
				destroy: function () {
					ui.removeListener(this.listener);
				}
			}));
	}
};

/**
 * Adds the label menu items to the given menu and parent.
 */
DiagramFormatPanel.prototype.addDocumentProperties = function (div) {
	// Hook for subclassers
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;

	div.appendChild(this.createTitle(mxResources.get('options')));

	return div;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
DiagramFormatPanel.prototype.addPaperSize = function (div) {
	var ui = this.editorUi;
	var editor = ui.editor;
	var graph = editor.graph;

	div.appendChild(this.createTitle(mxResources.get('paperSize')));

	var accessor = PageSetupDialog.addPageFormatPanel(div, 'formatpanel', graph.pageFormat, function (pageFormat) {
		if (graph.pageFormat == null || graph.pageFormat.width != pageFormat.width || graph.pageFormat.height != pageFormat.height) {
			ui.setPageFormat(pageFormat);
		}
	});

	this.addKeyHandler(accessor.widthInput, function () {
		accessor.set(graph.pageFormat);
	});
	-this.addKeyHandler(accessor.heightInput, function () {
		accessor.set(graph.pageFormat);
	});

	var listener = function () {
		accessor.set(graph.pageFormat);
	};

	ui.addListener('pageFormatChanged', listener);
	this.listeners.push({
		destroy: function () {
			ui.removeListener(listener);
		}
	});

	graph.getModel().addListener(mxEvent.CHANGE, listener);
	this.listeners.push({
		destroy: function () {
			graph.getModel().removeListener(listener);
		}
	});

	return div;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
DiagramFormatPanel.prototype.addStyleOps = function (div) {
	var btn = mxUtils.button(mxResources.get('editData'), mxUtils.bind(this, function (evt) {
		this.editorUi.actions.get('editData').funct();
	}));

	btn.setAttribute('title', mxResources.get('editData') + ' (' + this.editorUi.actions.get('editData').shortcut + ')');
	btn.style.width = '202px';
	btn.style.marginBottom = '2px';
	div.appendChild(btn);

	mxUtils.br(div);

	btn = mxUtils.button(mxResources.get('clearDefaultStyle'), mxUtils.bind(this, function (evt) {
		this.editorUi.actions.get('clearDefaultStyle').funct();
	}));

	btn.setAttribute('title', mxResources.get('clearDefaultStyle') + ' (' + this.editorUi.actions.get('clearDefaultStyle').shortcut + ')');
	btn.style.width = '202px';
	div.appendChild(btn);

	return div;
};

/**
 * Adds the label menu items to the given menu and parent.
 */
DiagramFormatPanel.prototype.destroy = function () {
	BaseFormatPanel.prototype.destroy.apply(this, arguments);

	if (this.gridEnabledListener) {
		this.editorUi.removeListener(this.gridEnabledListener);
		this.gridEnabledListener = null;
	}
};
